const HomePageSvg = () => {
  return (
    <svg
      width="1166"
      height="906"
      viewBox="0 0 1166 906"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1081.54 906C1061.66 906 1045.79 898.234 1033.57 883.258C1008.94 852.196 998 790.627 998 696.332V695.777C998 563.209 1026.82 485 1083.55 485C1102.16 485 1117.11 493.32 1129.34 510.515C1153.96 544.905 1166 608.693 1166 696.332V696.887C1166 840.548 1140.28 906 1081.54 906ZM1081.91 720.183C1088.48 720.183 1091.39 713.527 1091.39 696.332C1091.39 680.246 1088.48 672.481 1082.09 672.481C1075.71 672.481 1072.61 680.246 1072.61 696.332C1072.61 713.527 1075.89 720.183 1081.91 720.183Z"
        fill="white"
      />
      <path d="M874 487H973.6V906H874V487Z" fill="white" />
      <path
        d="M652 659.8V487H759.52C779.44 487 796.48 490.36 811.6 497.08C841.84 510.28 859.36 535.96 859.36 572.92C859.12 629.08 824.32 659.8 760.24 659.8H652ZM744.64 563.8V583.48H753.52C762.88 583.48 766 580.36 766 573.4C765.76 565.96 762.16 563.8 751.84 563.8H744.64Z"
        fill="white"
      />
      <path
        d="M530.6 664.36C490.76 664.36 466.04 657.4 451.16 643C436.28 628.12 431 605.8 431 573.64V487H527.48V573.88C527.48 580.84 528.44 582.52 532.04 582.52C535.16 582.52 536.12 580.84 536.12 573.88V487H631.64V573.64C631.64 594.76 628.28 611.8 621.56 625.24C608.12 652.36 579.56 664.36 530.6 664.36Z"
        fill="white"
      />
      <path
        d="M379.08 563.28V906H274.68V563.28H237V486H416.76V563.28H379.08Z"
        fill="white"
      />
      <path
        d="M113.28 664.32C70.56 664.32 43.44 658.8 26.64 648.24C9.6 637.68 2.64 621.84 0 600.96H102.24C102.96 604.08 108.96 605.76 118.56 605.76C126 605.76 128.4 605.28 128.4 603.36C128.4 602.16 127.44 601.68 121.68 600.96C115.92 600.72 104.88 600 84 598.8C50.88 596.88 30.48 592.08 18.96 583.44C7.44 575.04 3.6 562.08 3.6 543.84C3.6 504.96 38.88 480 109.2 480C132.72 480 151.68 481.92 167.04 486.48C197.52 494.88 214.8 512.4 223.2 540.48H123.12C121.92 536.88 117.84 535.2 107.76 535.2C100.08 535.2 98.64 536.4 98.64 538.08C98.64 539.04 99.12 539.52 104.64 540.24C110.16 540.96 120.96 541.68 142.56 542.64C162.24 543.6 177.84 546 190.08 549.84C214.56 557.76 225.12 572.64 225.12 599.04C225.12 641.76 186.72 664.32 113.28 664.32Z"
        fill="white"
      />
      <path
        d="M776.08 365.28V460.8H671.68V365.28H634V288L1166 288V365.28H776.08Z"
        fill="white"
      />
      <path
        d="M466.96 460.8H364L406.96 366.24L368.08 288H467.68L481.12 320.4L483.28 351.12L485.68 320.4L499.36 288H599.68L557.68 365.76L603.52 460.8H500.8L485.2 422.16L483.28 392.64L481.36 422.16L466.96 460.8Z"
        fill="white"
      />
      <path
        d="M344.64 460.8H168V288H344.64V351.36H258.72V357.6H344.64V387.84H258.72V394.32H344.64V460.8Z"
        fill="white"
      />
      <path
        d="M142.08 269.28V364.8H37.68V269.28H0V192L1166 192V269.28H142.08Z"
        fill="white"
      />
      <path d="M1023 47H1159.32V124.04H1023V47Z" fill="white" />
      <path
        d="M866 125.52V172.8H770V0H884.24C906.08 0 924.08 1.92 938.96 5.03999C968.48 12 983.36 27.12 983.36 54.48C983.36 65.04 980.48 73.2 974.48 78.96C962.96 90.24 941.6 94.08 914.24 95.28C941.84 95.28 958.64 97.68 968.24 104.64C977.6 112.08 980.72 125.04 980.72 147.12V157.2C980.72 165.6 984.8 170.16 990.56 172.8H881.6C876.56 170.16 874.64 165.36 874.64 161.28V131.52C874.64 126.48 872.72 125.52 866.96 125.52H866ZM866 67.44V83.52H872.48C878.24 83.52 880.88 80.64 880.88 75.12C880.88 70.08 878.24 67.44 872.48 67.44H866Z"
        fill="white"
      />
      <path
        d="M758.64 172.8H582V0H758.64V63.36H672.72V69.6H758.64V99.84H672.72V106.32H758.64V172.8Z"
        fill="white"
      />
      <path
        d="M532.58 77.28V172.8H428.18V77.28H364V0L570.26 0V77.28H532.58Z"
        fill="white"
      />
      <path d="M249 172.8V0H349.08V88.8H407.16V172.8H249Z" fill="white" />
      <path
        d="M138.48 159.12H98.16L94.8 172.8H0L56.64 0H236.88V172.8H141.84L138.48 159.12ZM112.56 102.24H125.04L121.2 86.4L118.8 54.96L116.4 86.4L112.56 102.24Z"
        fill="white"
      />
      <rect x="37" y="379" width="105" height="86" fill="white" />
      <path d="M0 684H237V906H0L0 684Z" fill="white" />
      <path d="M417 684H846V906H417V684Z" fill="white" />
      <rect x="793" y="379" width="373" height="82" fill="white" />
    </svg>
  );
};

const HomePageSvgMobile = () => {
  return (
    <svg
      width="352"
      height="781"
      viewBox="0 0 352 781"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.3516 98.5292H63.5005L61.4296 107H3L37.9098 0H149V107H90.4225L88.3516 98.5292ZM72.3759 63.3083H80.0679L77.7011 53.5L76.2219 34.0319L74.7427 53.5L72.3759 63.3083Z"
        fill="white"
      />
      <path d="M155 107V0H217.012V54.9861H253V107H155Z" fill="white" />
      <path
        d="M327.617 47.8528V107H262.829V47.8528H223V0L351 0V47.8528H327.617Z"
        fill="white"
      />
      <path
        d="M112 221H3V114H112V153.233H58.981V157.097H112V175.822H58.981V179.835H112V221Z"
        fill="white"
      />
      <path
        d="M178.63 191.724V221H119V114H189.96C203.526 114 214.706 115.189 223.949 117.121C242.285 121.431 251.528 130.793 251.528 147.735C251.528 154.274 249.739 159.326 246.012 162.893C238.856 169.878 225.589 172.256 208.594 172.999C225.738 172.999 236.173 174.485 242.136 178.794C247.95 183.401 249.888 191.426 249.888 205.099V211.34C249.888 216.542 252.422 219.365 256 221H188.32C185.189 219.365 183.997 216.393 183.997 213.867V195.439C183.997 192.318 182.804 191.724 179.226 191.724H178.63ZM178.63 155.76V165.717H182.655C186.233 165.717 187.873 163.933 187.873 160.515C187.873 157.394 186.233 155.76 182.655 155.76H178.63Z"
        fill="white"
      />
      <path d="M267 145H351V192H267V145Z" fill="white" />
      <path
        d="M81.5674 270.734V336H23.8363V270.734H3V228H351V270.734H81.5674Z"
        fill="white"
      />
      <path
        d="M297.805 301.939V334H262.678V301.939H250V276H351.5V301.939H297.805Z"
        fill="white"
      />
      <path
        d="M193.819 334H159L173.528 302.261L160.38 276H194.062L198.607 286.875L199.338 297.186L200.149 286.875L204.776 276H238.701L224.498 302.1L240 334H205.263L199.987 321.031L199.338 311.122L198.688 321.031L193.819 334Z"
        fill="white"
      />
      <path
        d="M153 334H94V276H153V297.267H124.302V299.361H153V309.511H124.302V311.686H153V334Z"
        fill="white"
      />
      <rect x="304" y="307" width="47" height="27" fill="white" />
      <path
        d="M62.6416 444.925C39.0183 444.925 24.0215 441.873 14.7314 436.033C5.30861 430.194 1.45987 421.435 0 409.888H56.5367C56.9348 411.614 60.2527 412.543 65.5613 412.543C69.6755 412.543 71.0027 412.277 71.0027 411.216C71.0027 410.552 70.4718 410.287 67.2866 409.888C64.1015 409.756 57.9966 409.358 46.4503 408.694C28.1356 407.632 16.8548 404.978 10.4845 400.2C4.11417 395.555 1.99073 388.389 1.99073 378.302C1.99073 356.802 21.4999 343 60.3854 343C73.3915 343 83.876 344.062 92.3698 346.583C109.225 351.228 118.78 360.917 123.425 376.444H68.0829C67.4193 374.454 65.1632 373.524 59.5891 373.524C55.3423 373.524 54.546 374.188 54.546 375.117C54.546 375.648 54.8114 375.913 57.8638 376.312C60.9163 376.71 66.8885 377.108 78.8329 377.639C89.7155 378.17 98.342 379.497 105.11 381.62C118.647 386 124.487 394.228 124.487 408.827C124.487 432.45 103.252 444.925 62.6416 444.925Z"
        fill="white"
      />
      <path
        d="M205.567 389.734V579.252H147.836V389.734H127V347H226.404V389.734H205.567Z"
        fill="white"
      />
      <path
        d="M296.077 445.077C274.046 445.077 260.376 441.228 252.148 433.265C243.92 425.037 241 412.694 241 394.91V347H294.352V395.043C294.352 398.892 294.882 399.821 296.873 399.821C298.598 399.821 299.129 398.892 299.129 395.043V347H351.95V394.91C351.95 406.589 350.092 416.012 346.376 423.444C338.944 438.441 323.151 445.077 296.077 445.077Z"
        fill="white"
      />
      <path
        d="M12 560.555V465H71.4564C82.4718 465 91.8946 466.858 100.256 470.574C116.978 477.873 126.666 492.074 126.666 512.512C126.533 543.567 107.29 560.555 71.8546 560.555H12ZM63.2281 507.469V518.352H68.1386C73.3144 518.352 75.0397 516.626 75.0397 512.777C74.907 508.663 72.9163 507.469 67.2096 507.469H63.2281Z"
        fill="white"
      />
      <path
        d="M305.248 781C294.241 781 285.456 775.171 278.691 763.93C265.059 740.615 259 694.402 259 623.624V623.208C259 523.704 274.954 465 306.358 465C316.658 465 324.938 471.245 331.704 484.152C345.336 509.964 352 557.843 352 623.624V624.041C352 731.872 337.762 781 305.248 781ZM305.45 641.527C309.085 641.527 310.7 636.531 310.7 623.624C310.7 611.551 309.085 605.722 305.55 605.722C302.016 605.722 300.3 611.551 300.3 623.624C300.3 636.531 302.117 641.527 305.45 641.527Z"
        fill="white"
      />
      <path d="M3 599H240V781H3V599Z" fill="white" />
    </svg>
  );
};

const DanteSvg = () => {
  return (
    <svg
      width="1342"
      height="735"
      viewBox="0 0 1342 735"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1141 675V517.917L1219.35 410.375H1141V240H1339.52V389.833L1262.85 500.396H1340V675H1141Z"
        fill="white"
      />
      <path
        d="M1027.9 488C1001.74 488 980.869 483.333 964.792 474.333C932.397 455.667 918 418.667 918 362V361.667C918 282 955.913 235 1030.54 235C1055.02 235 1074.69 240 1090.77 250.333C1123.16 271 1139 309.333 1139 362V362.333C1139 448.667 1105.17 488 1027.9 488ZM1028.38 376.333C1037.02 376.333 1040.86 372.333 1040.86 362C1040.86 352.333 1037.02 347.667 1028.62 347.667C1020.22 347.667 1016.14 352.333 1016.14 362C1016.14 372.333 1020.46 376.333 1028.38 376.333Z"
        fill="white"
      />
      <path
        d="M819.285 498.4L806.138 583.267V696H711V240H806.138V333.1L796.337 449L812.114 335.633L831.715 240H938.327L891.953 430L889.802 433.8L893.148 444.567L940 696H830.281L813.07 576.3L819.285 498.4Z"
        fill="white"
      />
      <path
        d="M616.55 468.367H576.21L572.848 488H478L534.669 240H659.532L715 488H619.912L616.55 468.367ZM590.617 386.733H603.103L599.261 364L596.86 318.878L594.459 364L590.617 386.733Z"
        fill="white"
      />
      <path
        d="M466.085 317.48V734.5H361.685V317.48H324.005V240.2H503.765V317.48H466.085Z"
        fill="white"
      />
      <path
        d="M224.28 642.32C181.56 642.32 154.44 636.8 137.64 626.24C120.6 615.68 113.64 599.84 111 578.96H213.24C213.96 582.08 219.96 583.76 229.56 583.76C237 583.76 239.4 583.28 239.4 581.36C239.4 580.16 238.44 579.68 232.68 578.96C226.92 578.72 215.88 578 195 576.8C161.88 574.88 141.48 570.08 129.96 561.44C118.44 553.04 114.6 540.08 114.6 521.84C114.6 482.96 149.88 458 220.2 458C243.72 458 262.68 459.92 278.04 464.48C308.52 472.88 325.8 490.4 334.2 518.48H234.12C232.92 514.88 228.84 513.2 218.76 513.2C211.08 513.2 209.64 514.4 209.64 516.08C209.64 517.04 210.12 517.52 215.64 518.24C221.16 518.96 231.96 519.68 253.56 520.64C273.24 521.6 288.84 524 301.08 527.84C325.56 535.76 336.12 550.64 336.12 577.04C336.12 619.76 297.72 642.32 224.28 642.32Z"
        fill="white"
      />
      <path d="M0.835938 240.2H100.436V546H0.835938V240.2Z" fill="white" />
      <path
        d="M1324.25 178C1316.88 178 1311.57 176.767 1306.17 173.807C1299.13 176.438 1292.1 177.918 1285.06 177.918C1278.19 177.918 1272.63 177.26 1268.54 175.945C1260.35 173.314 1257 168.053 1257 160.489C1257 150.706 1261.34 144.623 1274.51 141.334C1274.18 139.937 1274.02 138.539 1274.02 136.977C1274.02 133.031 1274.83 129.66 1276.72 126.536C1280.32 120.453 1287.11 117 1296.43 117C1311.32 117 1318.36 123.577 1318.36 133.689C1318.36 141.581 1314.59 147.007 1306.17 150.542C1307.07 151.199 1307.97 151.857 1308.7 152.515C1312.88 149.637 1316.39 146.102 1319.01 141.663H1342C1338.81 148.569 1334.23 154.817 1328.42 160.078C1333.25 159.832 1338.32 157.283 1340.36 155.228V173.725C1337.99 176.52 1333.49 178 1324.25 178ZM1294.63 136.073C1294.63 136.484 1294.71 137.142 1295.04 137.881C1296.92 137.306 1297.5 136.648 1297.5 135.662C1297.5 134.675 1297.09 134.264 1296.1 134.264C1295.12 134.264 1294.63 134.84 1294.63 136.073ZM1285.55 159.338C1286.21 159.338 1286.86 159.338 1287.43 159.256C1286.37 158.27 1285.31 157.283 1284.32 156.296C1282.03 156.872 1281.71 157.447 1281.71 158.105C1281.71 159.092 1282.44 159.338 1285.55 159.338Z"
        fill="white"
      />
      <path
        d="M1228.7 173H839.594V0.200195H1228.7V63.5602H930.314V69.8002H1228.7V100.04H930.314V106.52H1228.7V173Z"
        fill="white"
      />
      <path
        d="M794.608 77.4802V173H690.208V77.4802H652.528V0.200195H832.288V77.4802H794.608Z"
        fill="white"
      />
      <path
        d="M517.384 173H424.984V0.200195H531.544L572.344 106.52L553.864 44.8402V0.200195H645.304V173H540.664L498.184 60.6802L517.384 125.24V173Z"
        fill="white"
      />
      <path
        d="M330.666 159.32H290.346L286.986 173H192.186L248.826 0.200195H373.626L429.066 173H334.026L330.666 159.32ZM304.746 102.44H317.226L313.386 86.6002L310.986 55.1602L308.586 86.6002L304.746 102.44Z"
        fill="white"
      />
      <path
        d="M1 173V0.200195H108.52C128.44 0.200195 145.48 3.56019 160.6 10.2802C190.84 23.4802 208.36 49.1602 208.36 86.1202C208.12 142.28 173.32 173 109.24 173H1ZM93.64 77.0002V96.6802H102.52C111.88 96.6802 115 93.5602 115 86.6002C114.76 79.1602 111.16 77.0002 100.84 77.0002H93.64Z"
        fill="white"
      />
    </svg>
  );
};

const VialandSvg = () => {
  return (
    <svg
      width="1324"
      height="760"
      viewBox="0 0 1324 760"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M645 759V194H996.555C1061.69 194 1117.4 204.986 1166.84 226.958C1265.72 270.118 1323 354.083 1323 474.931C1322.22 658.556 1208.43 759 998.91 759H645ZM947.903 445.111V509.458H976.937C1007.54 509.458 1017.74 499.257 1017.74 476.5C1016.96 452.174 1005.19 445.111 971.445 445.111H947.903Z"
        fill="white"
      />
      <path
        d="M407.788 494H248V195H432.275L502.83 378.968L470.872 272.242V195H629V494H448.046L374.585 299.65L407.788 411.36V494Z"
        fill="white"
      />
      <path
        d="M139.32 746H98.9999L95.6399 759.68H0.839844L60.64 195H185.44L237.72 759.68H142.68L139.32 746ZM116.56 297.24H129.04L125.2 281.4L122.8 249.96L120.4 281.4L116.56 297.24Z"
        fill="white"
      />
      <path d="M1165 172.8V0H1265.08V88.8H1323.16V172.8H1165Z" fill="white" />
      <path
        d="M1048.48 159.12H1008.16L1004.8 172.8H910L966.64 0H1091.44L1146.88 172.8H1051.84L1048.48 159.12ZM1022.56 102.24H1035.04L1031.2 86.4L1028.8 54.96L1026.4 86.4L1022.56 102.24Z"
        fill="white"
      />
      <path d="M248 0H890V173H248V0Z" fill="white" />
      <path
        d="M63.362 172.8L10.082 0H108.722L120.722 50.4L122.882 93.84L125.282 50.16L138.002 0H234.242L179.282 172.8H63.362Z"
        fill="white"
      />
    </svg>
  );
};

const DesteSvg = () => {
  return (
    <svg
      width="1372"
      height="758"
      viewBox="0 0 1372 758"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1233.57 30H1369.37L1306.57 96.8101H1193.79L1233.57 30ZM1372 342H1130V105.038H1372V191.924H1254.29V200.481H1372V241.949H1254.29V250.835H1372V342Z"
        fill="white"
      />
      <path
        d="M1103.82 77.28V757.5L920 757.5V77.2802H725V0.000213623L1141.5 0V77.28H1103.82Z"
        fill="white"
      />
      <path
        d="M782.22 468C739.522 468 712.417 462.639 695.626 452.384C678.595 442.129 671.639 426.746 669 406.469H771.186C771.905 409.499 777.902 411.13 787.497 411.13C794.933 411.13 797.332 410.664 797.332 408.799C797.332 407.634 796.372 407.168 790.615 406.469C784.858 406.236 773.824 405.536 752.955 404.371C719.853 402.507 699.464 397.845 687.95 389.454C676.436 381.297 672.598 368.711 672.598 350.997C672.598 313.24 707.859 289 778.142 289C801.649 289 820.599 290.865 835.951 295.293C866.415 303.451 883.685 320.465 892.081 347.734H792.054C790.855 344.238 786.777 342.607 776.703 342.607C769.027 342.607 767.587 343.772 767.587 345.404C767.587 346.336 768.067 346.802 773.584 347.501C779.101 348.201 789.896 348.9 811.484 349.832C831.154 350.764 846.745 353.095 858.979 356.824C883.446 364.516 894 378.966 894 404.604C894 446.091 855.62 468 782.22 468Z"
        fill="white"
      />
      <path
        d="M636.64 757.98H460V0H636.64V63.36H550.72V69.6H636.64V99.84H550.72V106.5H636.64V757.98Z"
        fill="white"
      />
      <path
        d="M0 357V0H221.926C263.042 0 298.213 6.94166 329.421 20.825C391.838 48.0958 428 101.15 428 177.508C427.505 293.533 355.676 357 223.412 357H0ZM191.213 158.667V199.325H209.542C228.861 199.325 235.301 192.879 235.301 178.5C234.806 163.129 227.375 158.667 206.074 158.667H191.213Z"
        fill="white"
      />
    </svg>
  );
};

const MuralSvg = () => {
  return (
    <svg
      width="1409"
      height="743"
      viewBox="0 0 1409 743"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1371.08 556.28V651.8H1266.68V556.28H1229V479H1408.76V556.28H1371.08Z"
        fill="white"
      />
      <path
        d="M1059.53 743C998.239 743 959.327 735.094 935.223 719.969C910.774 704.844 900.788 682.156 897 652.25H1043.69C1044.73 656.719 1053.33 659.125 1067.11 659.125C1077.78 659.125 1081.23 658.437 1081.23 655.687C1081.23 653.969 1079.85 653.281 1071.59 652.25C1063.32 651.906 1047.48 650.875 1017.52 649.156C970.002 646.406 940.732 639.531 924.204 627.156C907.675 615.125 902.165 596.563 902.165 570.438C902.165 514.75 952.785 479 1053.68 479C1087.43 479 1114.63 481.75 1136.67 488.281C1180.4 500.312 1205.19 525.406 1217.25 565.625H1073.65C1071.93 560.469 1066.08 558.062 1051.61 558.062C1040.59 558.062 1038.53 559.781 1038.53 562.187C1038.53 563.562 1039.22 564.25 1047.14 565.281C1055.06 566.312 1070.55 567.344 1101.54 568.719C1129.78 570.094 1152.16 573.531 1169.72 579.031C1204.85 590.375 1220 611.688 1220 649.5C1220 710.688 1164.9 743 1059.53 743Z"
        fill="white"
      />
      <path
        d="M747.041 722.1H685.594L680.473 743H536L622.318 479H812.511L897 743H752.161L747.041 722.1ZM707.539 635.2H726.558L720.706 611L717.049 562.967L713.391 611L707.539 635.2Z"
        fill="white"
      />
      <path
        d="M527 743H257V479H527V575.8H395.668V585.333H527V631.533H395.668V641.433H527V743Z"
        fill="white"
      />
      <path d="M0 479H248V556H0V479Z" fill="white" />
      <path d="M933 459V0H1352.14V375.091H1407V459H933Z" fill="white" />
      <path
        d="M824.48 159.12H784.16L780.8 172.8H686L742.64 0H867.44L922.88 172.8H827.84L824.48 159.12ZM798.56 102.24H811.04L807.2 86.4L804.8 54.96L802.4 86.4L798.56 102.24Z"
        fill="white"
      />
      <path
        d="M561.192 336.318V463H465V0H579.468C601.351 0 619.387 5.14446 634.297 13.5041C663.876 32.1528 678.786 72.6653 678.786 145.974C678.786 174.268 675.9 196.132 669.888 211.565C658.345 241.789 636.942 252.078 609.528 255.293C637.183 255.293 654.016 261.724 663.635 280.372C673.014 300.307 676.14 335.032 676.14 394.193V421.201C676.14 443.708 680.229 455.926 686 463H576.823C571.773 455.926 569.849 443.065 569.849 432.133V352.394C569.849 338.89 567.925 336.318 562.153 336.318H561.192ZM561.192 180.699V223.783H567.684C573.456 223.783 576.101 216.067 576.101 201.276C576.101 187.772 573.456 180.699 567.684 180.699H561.192Z"
        fill="white"
      />
      <path
        d="M356.229 177.36C316.389 177.36 291.669 170.4 276.789 156C261.909 141.12 256.629 118.8 256.629 86.64V0H353.109V86.88C353.109 93.84 354.069 95.52 357.669 95.52C360.789 95.52 361.749 93.84 361.749 86.88V0H457.269V86.64C457.269 107.76 453.909 124.8 447.189 138.24C433.749 165.36 405.189 177.36 356.229 177.36Z"
        fill="white"
      />
      <path
        d="M85.2 462.5H0L0 0H117.6L123.36 48L124.56 99.12L126.48 48L132.96 0H248.4V462.5H162.48V426.02L175.92 338.9L150.96 462.5H96.72L72.72 338.42L85.2 426.5V462.5Z"
        fill="white"
      />
    </svg>
  );
};

const BubbleSvg = () => {
  return (
    <svg
      width="1388"
      height="742"
      viewBox="0 0 1388 742"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1080.98 710C963.702 710 889.252 694.876 843.132 665.944C796.354 637.012 777.247 593.613 770 536.406H1050.67C1052.65 544.954 1069.12 549.557 1095.47 549.557C1115.9 549.557 1122.48 548.242 1122.48 542.982C1122.48 539.694 1119.85 538.379 1104.04 536.406C1088.22 535.749 1057.92 533.776 1000.6 530.488C909.676 525.228 853.674 512.077 822.049 488.405C790.425 465.391 779.883 429.883 779.883 379.909C779.883 273.385 876.734 205 1069.78 205C1134.34 205 1186.39 210.26 1228.56 222.754C1312.23 245.768 1359.67 293.769 1382.73 370.703H1107.99C1104.7 360.84 1093.49 356.237 1065.82 356.237C1044.74 356.237 1040.79 359.525 1040.79 364.128C1040.79 366.758 1042.1 368.073 1057.26 370.046C1072.41 372.018 1102.06 373.991 1161.36 376.621C1215.38 379.251 1258.21 385.827 1291.81 396.348C1359.01 418.047 1388 458.815 1388 531.146C1388 648.19 1282.58 710 1080.98 710Z"
        fill="white"
      />
      <path
        d="M598.08 293.28V742H493.68V293.28H456V216H772.5V293.28H598.08Z"
        fill="white"
      />
      <path
        d="M334.92 389.16C308.76 389.16 287.88 385.8 271.8 379.32C239.4 365.88 225 339.24 225 298.44V298.2C225 240.84 262.92 207 337.56 207C362.04 207 381.72 210.6 397.8 218.04C430.2 232.92 446.04 260.52 446.04 298.44V298.68C446.04 360.84 412.2 389.16 334.92 389.16ZM335.4 308.76C344.04 308.76 347.88 305.88 347.88 298.44C347.88 291.48 344.04 288.12 335.64 288.12C327.24 288.12 323.16 291.48 323.16 298.44C323.16 305.88 327.48 308.76 335.4 308.76Z"
        fill="white"
      />
      <path
        d="M0 728V207H124.196C145.335 207 161.911 212.065 174.883 221.472C200.587 241.01 211.397 280.085 211.397 340.868C211.397 363.3 209.715 382.838 206.832 398.033C200.346 431.319 185.933 450.857 156.866 460.264C171.76 463.882 183.05 470.394 191.458 479.801C208.514 497.892 215 529.731 215 580.383C215 615.117 211.397 642.614 203.95 665.046C189.056 708.462 161.911 728 124.676 728H0ZM93.6871 390.797V419.018H105.458C109.302 419.018 110.983 413.953 110.983 404.546C110.983 395.139 109.302 390.797 105.698 390.797H93.6871ZM93.6871 510.193V538.414H107.62C112.184 538.414 113.145 533.349 113.145 523.942C113.145 514.535 111.223 510.193 107.38 510.193H93.6871Z"
        fill="white"
      />
      <path
        d="M1387.64 175.8H1211V3H1387.64V66.36H1301.72V72.6H1387.64V102.84H1301.72V109.32H1387.64V175.8Z"
        fill="white"
      />
      <path d="M770 172.8V0H870.08V88.8H1196V172.8H770Z" fill="white" />
      <path
        d="M438 172.8V0H562.08C583.2 0 599.76 1.67999 612.72 4.8C638.4 11.28 649.2 24.24 649.2 44.4C649.2 51.84 647.52 58.32 644.64 63.36C638.16 74.4 623.76 80.88 594.72 84C609.6 85.2 620.88 87.36 629.28 90.48C646.32 96.48 652.8 107.04 652.8 123.84C652.8 135.36 649.2 144.48 641.76 151.92C626.88 166.32 599.76 172.8 562.56 172.8H438ZM531.6 60.96V70.32H543.36C547.2 70.32 548.88 68.64 548.88 65.52C548.88 62.4 547.2 60.96 543.6 60.96H531.6ZM531.6 100.56V109.92H545.52C550.08 109.92 551.04 108.24 551.04 105.12C551.04 102 549.12 100.56 545.28 100.56H531.6Z"
        fill="white"
      />
      <path
        d="M315.448 177.36C275.608 177.36 250.888 170.4 236.008 156C221.128 141.12 215.848 118.8 215.848 86.64V0H312.328V86.88C312.328 93.84 313.288 95.52 316.888 95.52C320.008 95.52 320.968 93.84 320.968 86.88V0H416.488V86.64C416.488 107.76 413.128 124.8 406.408 138.24C392.968 165.36 364.408 177.36 315.448 177.36Z"
        fill="white"
      />
      <path
        d="M0 172.8V0H124.08C145.2 0 161.76 1.67999 174.72 4.8C200.4 11.28 211.2 24.24 211.2 44.4C211.2 51.84 209.52 58.32 206.64 63.36C200.16 74.4 185.76 80.88 156.72 84C171.6 85.2 182.88 87.36 191.28 90.48C208.32 96.48 214.8 107.04 214.8 123.84C214.8 135.36 211.2 144.48 203.76 151.92C188.88 166.32 161.76 172.8 124.56 172.8H0ZM93.6 60.96V70.32H105.36C109.2 70.32 110.88 68.64 110.88 65.52C110.88 62.4 109.2 60.96 105.6 60.96H93.6ZM93.6 100.56V109.92H107.52C112.08 109.92 113.04 108.24 113.04 105.12C113.04 102 111.12 100.56 107.28 100.56H93.6Z"
        fill="white"
      />
    </svg>
  );
};

const PeanutSvg = () => {
  return (
    <svg
      width="1381"
      height="735"
      viewBox="0 0 1381 735"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1219.82 734C1171.24 734 1140.4 727.741 1121.29 715.767C1101.92 703.793 1094 685.832 1091 662.156H1207.26C1208.08 665.694 1214.91 667.599 1225.82 667.599C1234.28 667.599 1237.01 667.055 1237.01 664.878C1237.01 663.517 1235.92 662.973 1229.37 662.156C1222.82 661.884 1210.27 661.068 1186.52 659.707C1148.86 657.53 1125.66 652.087 1112.56 642.29C1099.46 632.766 1095.09 618.07 1095.09 597.388C1095.09 553.302 1135.21 525 1215.18 525C1241.93 525 1263.49 527.177 1280.95 532.348C1315.61 541.872 1335.26 561.738 1344.82 593.578H1231.01C1229.64 589.496 1225 587.591 1213.54 587.591C1204.81 587.591 1203.17 588.952 1203.17 590.857C1203.17 591.945 1203.72 592.49 1209.99 593.306C1216.27 594.122 1228.55 594.939 1253.12 596.027C1275.49 597.116 1293.23 599.837 1307.15 604.191C1334.99 613.172 1347 630.044 1347 659.979C1347 708.419 1303.33 734 1219.82 734Z"
        fill="white"
      />
      <path
        d="M1069 734H892V196H1069V393.267H982.905V412.694H1069V506.844H982.905V527.019H1069V734Z"
        fill="white"
      />
      <path
        d="M706.2 733.8H621V561H738.6L744.36 609L745.56 660.12L747.48 609L753.96 561H869.4V733.8H783.48V697.32L796.92 610.2L771.96 733.8H717.72L693.72 609.72L706.2 697.8V733.8Z"
        fill="white"
      />
      <path
        d="M500.48 720.12H460.16L456.8 733.8H362L418.64 561H543.44L598.88 733.8H503.84L500.48 720.12ZM474.56 663.24H487.04L483.2 647.4L480.8 615.96L478.4 647.4L474.56 663.24Z"
        fill="white"
      />
      <path
        d="M254.44 677.76C252.52 692.88 248.92 704.4 243.4 712.56C232.12 728.88 215.08 734.16 192.52 734.16C145.48 734.16 121 709.2 121 654V653.52C121 584.4 162.28 552 238.84 552C262.36 552 281.56 554.64 296.92 559.68C327.88 570.24 343.96 591.84 348.04 628.56H249.16C248.2 625.92 245.56 624.72 239.08 624.72C228.04 624.72 223.24 631.44 223.24 647.52C223.24 663.36 227.32 668.64 238.36 668.64C246.76 668.64 249.88 666 251.56 661.2H229V634.08H347.56V729.6H257.56L254.44 677.76Z"
        fill="white"
      />
      <path
        d="M1342.82 77.28V511.5H1094.21V77.28H1056.53V0H1380.5V77.28H1342.82Z"
        fill="white"
      />
      <path
        d="M948.729 177.36C908.889 177.36 884.169 170.4 869.289 156C854.409 141.12 849.129 118.8 849.129 86.64V0H945.609V86.88C945.609 93.84 946.569 95.52 950.169 95.52C953.289 95.52 954.249 93.84 954.249 86.88V0H1049.77V86.64C1049.77 107.76 1046.41 124.8 1039.69 138.24C1026.25 165.36 997.689 177.36 948.729 177.36Z"
        fill="white"
      />
      <path
        d="M713.266 515H621V0H727.405L768.146 316.868L749.693 133.042V0H841V515H736.512L694.094 180.25L713.266 372.66V515Z"
        fill="white"
      />
      <path
        d="M526.55 474.229H486.21L482.848 515H388L444.669 0H569.532L625 515H529.912L526.55 474.229ZM500.617 304.708H513.103L509.261 257.5L506.86 163.799L504.459 257.5L500.617 304.708Z"
        fill="white"
      />
      <path
        d="M391.796 172.8H215.156V0H391.796V63.36H305.876V69.6H391.796V99.84H305.876V106.32H391.796V172.8Z"
        fill="white"
      />
      <path
        d="M96 149.04V733.5H0V0H113.52C175.68 0 209.76 25.68 209.76 74.88C209.76 125.28 174.96 149.04 112.8 149.04H96ZM96 67.44V84.48H101.76C107.52 84.48 110.16 81.36 110.16 75.6C110.16 70.08 107.52 67.44 101.76 67.44H96Z"
        fill="white"
      />
    </svg>
  );
};

const SSSvg = () => {
  return (
    <svg
      width="1388"
      height="676"
      viewBox="0 0 1388 676"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M442 676V503H932.518C1023.4 503 1101.13 506.364 1170.11 513.092C1308.07 526.307 1388 552.017 1388 589.019C1386.91 645.244 1228.14 676 935.803 676H442ZM864.634 579.889V599.592H905.146C947.847 599.592 962.081 596.468 962.081 589.5C960.986 582.051 944.563 579.889 897.482 579.889H864.634Z"
        fill="white"
      />
      <path
        d="M433.749 675.8H257.109V503H433.749V566.36H347.829V572.6H433.749V602.84H347.829V609.32H433.749V675.8Z"
        fill="white"
      />
      <path
        d="M85.2001 675.8H0V503H117.6L123.36 551L124.56 602.12L126.48 551L132.96 503H248.4V675.8H162.48V639.32L175.92 552.2L150.96 675.8H96.7201L72.7201 551.72L85.2001 639.8V675.8Z"
        fill="white"
      />
      <path
        d="M717.817 310C708.202 310 701.258 308.403 694.207 304.57C685.019 307.977 675.832 309.894 666.644 309.894C657.67 309.894 650.405 309.042 645.064 307.338C634.38 303.931 630 297.117 630 287.322C630 274.652 635.662 266.774 652.862 262.515C652.435 260.705 652.221 258.895 652.221 256.872C652.221 251.761 653.29 247.396 655.747 243.35C660.448 235.472 669.315 231 681.494 231C700.937 231 710.125 239.518 710.125 252.613C710.125 262.834 705.211 269.861 694.207 274.439C695.382 275.291 696.557 276.143 697.519 276.995C702.967 273.268 707.561 268.69 710.98 262.941H741C736.834 271.884 730.851 279.976 723.266 286.79C729.569 286.47 736.192 283.17 738.863 280.508V304.464C735.765 308.084 729.889 310 717.817 310ZM679.143 255.701C679.143 256.233 679.25 257.085 679.678 258.043C682.135 257.298 682.883 256.446 682.883 255.168C682.883 253.891 682.348 253.358 681.066 253.358C679.784 253.358 679.143 254.104 679.143 255.701ZM667.285 285.832C668.14 285.832 668.994 285.832 669.742 285.725C668.353 284.447 666.964 283.17 665.682 281.892C662.691 282.637 662.264 283.383 662.264 284.235C662.264 285.512 663.225 285.832 667.285 285.832Z"
        fill="white"
      />
      <path
        d="M283.301 460C176.463 460 108.639 446.224 66.6236 419.87C24.0085 393.516 6.60234 353.984 0 301.875H255.691C257.491 309.661 272.497 313.854 296.505 313.854C315.112 313.854 321.114 312.656 321.114 307.865C321.114 304.87 318.713 303.672 304.308 301.875C289.903 301.276 262.293 299.479 210.075 296.484C127.245 291.693 76.227 279.714 47.4168 258.151C18.6066 237.187 9.00321 204.844 9.00321 159.323C9.00321 62.2917 97.2346 0 273.097 0C331.918 0 379.335 4.79168 417.748 16.1719C493.975 37.1354 537.191 80.8594 558.198 150.937H307.909C304.908 141.953 294.705 137.76 269.496 137.76C250.289 137.76 246.688 140.755 246.688 144.948C246.688 147.344 247.888 148.542 261.693 150.339C275.498 152.135 302.507 153.932 356.527 156.328C405.744 158.724 444.758 164.714 475.369 174.297C536.591 194.062 563 231.198 563 297.083C563 403.698 466.966 460 283.301 460Z"
        fill="white"
      />
      <path
        d="M1091.3 460C984.463 460 916.639 446.224 874.624 419.87C832.008 393.516 814.602 353.984 808 301.875H1063.69C1065.49 309.661 1080.5 313.854 1104.51 313.854C1123.11 313.854 1129.11 312.656 1129.11 307.865C1129.11 304.87 1126.71 303.672 1112.31 301.875C1097.9 301.276 1070.29 299.479 1018.07 296.484C935.245 291.693 884.227 279.714 855.417 258.151C826.607 237.187 817.003 204.844 817.003 159.323C817.003 62.2917 905.235 0 1081.1 0C1139.92 0 1187.33 4.79168 1225.75 16.1719C1301.98 37.1354 1345.19 80.8594 1366.2 150.937H1115.91C1112.91 141.953 1102.7 137.76 1077.5 137.76C1058.29 137.76 1054.69 140.755 1054.69 144.948C1054.69 147.344 1055.89 148.542 1069.69 150.339C1083.5 152.135 1110.51 153.932 1164.53 156.328C1213.74 158.724 1252.76 164.714 1283.37 174.297C1344.59 194.062 1371 231.198 1371 297.083C1371 403.698 1274.97 460 1091.3 460Z"
        fill="white"
      />
    </svg>
  );
};

const ToolsySvg = () => {
  return (
    <svg
      width="1396"
      height="747"
      viewBox="0 0 1396 747"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1054.79 747V633.136L920 389H1126.91L1152.78 452.147L1157.25 530.211L1162.23 451.65L1186.6 389H1396L1261.21 633.136V747H1054.79Z"
        fill="white"
      />
      <path
        d="M1014.76 334C939.806 334 892.221 324.327 862.743 305.822C832.844 287.316 820.632 259.559 816 222.969H995.392C996.656 228.436 1007.18 231.38 1024.03 231.38C1037.08 231.38 1041.29 230.539 1041.29 227.174C1041.29 225.072 1039.61 224.23 1029.5 222.969C1019.4 222.548 1000.02 221.286 963.388 219.184C905.275 215.819 869.481 207.408 849.268 192.267C829.055 177.547 822.317 154.836 822.317 122.872C822.317 54.7396 884.22 11 1007.6 11C1048.87 11 1082.14 14.3646 1109.09 22.3555C1162.57 37.0755 1192.89 67.7773 1207.63 116.984H1032.03C1029.92 110.676 1022.76 107.732 1005.08 107.732C991.602 107.732 989.076 109.835 989.076 112.779C989.076 114.461 989.918 115.302 999.603 116.564C1009.29 117.826 1028.24 119.087 1066.14 120.77C1100.67 122.452 1128.04 126.658 1149.52 133.387C1192.47 147.266 1211 173.341 1211 219.604C1211 294.466 1143.62 334 1014.76 334Z"
        fill="white"
      />
      <path d="M646 745V0H745.979V382.847H804V745H646Z" fill="white" />
      <path
        d="M500.92 551.16C474.76 551.16 453.88 547.8 437.8 541.32C405.4 527.88 391 501.24 391 460.44V460.2C391 402.84 428.92 369 503.56 369C528.04 369 547.72 372.6 563.8 380.04C596.2 394.92 612.04 422.52 612.04 460.44V460.68C612.04 522.84 578.2 551.16 500.92 551.16ZM501.4 470.76C510.04 470.76 513.88 467.88 513.88 460.44C513.88 453.48 510.04 450.12 501.64 450.12C493.24 450.12 489.16 453.48 489.16 460.44C489.16 467.88 493.48 470.76 501.4 470.76Z"
        fill="white"
      />
      <path
        d="M305.92 741.16C279.76 741.16 258.88 737.8 242.8 731.32C210.4 717.88 196 691.24 196 650.44V650.2C196 592.84 233.92 559 308.56 559C333.04 559 352.72 562.6 368.8 570.04C401.2 584.92 417.04 612.52 417.04 650.44V650.68C417.04 712.84 383.2 741.16 305.92 741.16ZM306.4 660.76C315.04 660.76 318.88 657.88 318.88 650.44C318.88 643.48 315.04 640.12 306.64 640.12C298.24 640.12 294.16 643.48 294.16 650.44C294.16 657.88 298.48 660.76 306.4 660.76Z"
        fill="white"
      />
      <path
        d="M142.08 645.48V741H37.68V645.48H0V16H179.76V645.48H142.08Z"
        fill="white"
      />
    </svg>
  );
};

const GolfSvg = () => {
  return (
    <svg
      width="1387"
      height="735"
      viewBox="0 0 1387 735"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1265.24 735C1221.4 735 1193.57 729.34 1176.34 718.512C1158.85 707.684 1151.71 691.441 1149 670.031H1253.91C1254.65 673.23 1260.81 674.953 1270.66 674.953C1278.29 674.953 1280.75 674.461 1280.75 672.492C1280.75 671.262 1279.77 670.77 1273.86 670.031C1267.95 669.785 1256.62 669.047 1235.19 667.816C1201.21 665.848 1180.28 660.926 1168.46 652.066C1156.63 643.453 1152.69 630.164 1152.69 611.461C1152.69 571.594 1188.9 546 1261.05 546C1285.19 546 1304.64 547.969 1320.4 552.645C1351.68 561.258 1369.41 579.223 1378.03 608.016H1275.34C1274.1 604.324 1269.92 602.602 1259.57 602.602C1251.69 602.602 1250.22 603.832 1250.22 605.555C1250.22 606.539 1250.71 607.031 1256.37 607.77C1262.04 608.508 1273.12 609.246 1295.28 610.23C1315.48 611.215 1331.49 613.676 1344.04 617.613C1369.16 625.734 1380 640.992 1380 668.063C1380 711.867 1340.6 735 1265.24 735Z"
        fill="white"
      />
      <path
        d="M1002.83 730V673.704L936 553H1038.59L1051.41 584.221L1053.63 622.817L1056.1 583.975L1068.18 553H1172L1105.17 673.704V730H1002.83Z"
        fill="white"
      />
      <path
        d="M889.642 688.438H848.11L844.649 730H747L805.342 205H933.894L991 730H893.103L889.642 688.438ZM862.943 515.625H875.798L871.843 467.5L869.371 371.979L866.899 467.5L862.943 515.625Z"
        fill="white"
      />
      <path
        d="M597.235 730H465.721L441 553H544.086L547.052 619.375L544.827 666.083L551.007 619.375L559.412 553H654.093L661.015 619.375L666.948 667.558L664.97 619.375L669.173 553H773L746.302 730H615.034L608.36 664.362L606.629 602.413L604.157 664.362L597.235 730Z"
        fill="white"
      />
      <path d="M289 730V553H392.143V643.958H452V730H289Z" fill="white" />
      <path
        d="M192.058 715.988H150.696L147.249 730H50L108.103 553H236.128L293 730H195.505L192.058 715.988ZM165.468 657.725H178.271L174.331 641.5L171.869 609.296L169.407 641.5L165.468 657.725Z"
        fill="white"
      />
      <path
        d="M1304.9 137.96V177.8H829V5L1386.5 5V77.24H1304.9V84.44H1386.5V137.96H1304.9Z"
        fill="white"
      />
      <path
        d="M653.578 177.6V4.80029H753.658V158.5H811.738V177.6H653.578Z"
        fill="white"
      />
      <path
        d="M607.848 182C601.22 182 595.931 181.152 591.857 179.515C583.648 176.121 580 169.394 580 159.091V159.03C580 144.545 589.607 136 608.517 136C614.719 136 619.705 136.909 623.779 138.788C631.987 142.545 636 149.515 636 159.091V159.152C636 174.848 627.427 182 607.848 182ZM607.97 161.697C610.159 161.697 611.131 160.97 611.131 159.091C611.131 157.333 610.159 156.485 608.03 156.485C605.902 156.485 604.869 157.333 604.869 159.091C604.869 160.97 605.963 161.697 607.97 161.697Z"
        fill="white"
      />
      <path
        d="M313.264 295.484C308.757 331.009 300.305 358.076 287.347 377.249C260.866 415.594 220.863 428 167.901 428C57.4693 428 0 369.354 0 239.657V238.53C0 76.1265 96.9092 0 276.642 0C331.857 0 376.931 6.20288 412.991 18.0448C485.672 42.8564 523.422 93.6074 533 179.884H300.869C298.615 173.681 292.418 170.862 277.205 170.862C251.288 170.862 240.019 186.651 240.019 224.432C240.019 261.65 249.597 274.055 275.515 274.055C295.235 274.055 302.559 267.852 306.503 256.574H253.541V192.854H531.873V417.286H320.589L313.264 295.484Z"
        fill="white"
      />
    </svg>
  );
};

const PremeyoumSvg = () => {
  return (
    <svg
      width="1381"
      height="760"
      viewBox="0 0 1381 760"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M610 455H434V0H610V166.833H524.391V183.264H610V262.889H524.391V279.951H610V455Z"
        fill="white"
      />
      <path
        d="M311.192 330.507V455H215V0H329.468C351.351 0 369.387 5.05557 384.297 13.2708C413.876 31.5972 428.786 71.4097 428.786 143.451C428.786 171.257 425.9 192.743 419.888 207.91C408.345 237.611 386.942 247.722 359.528 250.882C387.183 250.882 404.016 257.201 413.635 275.528C423.014 295.118 426.14 329.243 426.14 387.382V413.924C426.14 436.042 430.229 448.049 436 455H326.823C321.773 448.049 319.849 435.41 319.849 424.667V346.306C319.849 333.035 317.925 330.507 312.153 330.507H311.192ZM311.192 177.576V219.917H317.684C323.456 219.917 326.101 212.333 326.101 197.799C326.101 184.528 323.456 177.576 317.684 177.576H311.192Z"
        fill="white"
      />
      <path
        d="M96.1098 392.438V455H0V0H113.65C175.881 0 210 67.6181 210 197.167C210 329.875 175.16 392.438 112.929 392.438H96.1098ZM96.1098 177.576V222.444H101.876C107.643 222.444 110.286 214.229 110.286 199.063C110.286 184.528 107.643 177.576 101.876 177.576H96.1098Z"
        fill="white"
      />
      <path
        d="M701.063 455H616V0H733.411L739.161 126.389L740.359 260.993L742.276 126.389L748.746 0H864V455H778.218V358.944L791.637 129.549L766.717 455H712.564L688.603 128.285L701.063 360.208V455Z"
        fill="white"
      />
      <path
        d="M1381 455H873V0H1381V166.833H1133.9V183.264H1381V262.889H1133.9V279.951H1381V455Z"
        fill="white"
      />
      <path
        d="M721.312 752H636V474H753.755L759.522 551.222L760.724 633.464L762.647 551.222L769.135 474H1379V752H798.694V693.311L812.152 553.153L787.159 752H732.847L708.816 552.381L721.312 694.083V752Z"
        fill="white"
      />
      <path
        d="M527.282 760C487.569 760 462.928 748.777 448.096 725.556C433.263 701.562 428 665.57 428 613.71V474H524.172V614.097C524.172 625.321 525.129 628.03 528.718 628.03C531.828 628.03 532.785 625.321 532.785 614.097V474H628V613.71C628 647.767 624.651 675.245 617.952 696.917C604.555 740.65 576.086 760 527.282 760Z"
        fill="white"
      />
      <path
        d="M310.9 760C284.745 760 263.869 754.559 247.792 744.065C215.397 722.299 201 679.157 201 613.083V612.694C201 519.802 238.913 465 313.54 465C338.015 465 357.692 470.83 373.769 482.879C406.163 506.976 422 551.673 422 613.083V613.472C422 714.137 388.166 760 310.9 760ZM311.38 629.796C320.018 629.796 323.858 625.132 323.858 613.083C323.858 601.812 320.018 596.37 311.62 596.37C303.221 596.37 299.142 601.812 299.142 613.083C299.142 625.132 303.461 629.796 311.38 629.796Z"
        fill="white"
      />
      <path
        d="M65.1306 752V663.581L0 474H99.979L112.476 523.036L114.639 583.656L117.043 522.65L128.819 474H230L164.869 663.581V752H65.1306Z"
        fill="white"
      />
    </svg>
  );
};

const OusSvg = () => {
  return (
    <svg
      width="1397"
      height="760"
      viewBox="0 0 1397 760"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1284.17 184.32C1241.45 184.32 1214.33 178.8 1197.53 168.24C1180.49 157.68 1173.53 141.84 1170.89 120.96H1273.13C1273.85 124.08 1279.85 125.76 1289.45 125.76C1296.89 125.76 1299.29 125.28 1299.29 123.36C1299.29 122.16 1298.33 121.68 1292.57 120.96C1286.81 120.72 1275.77 120 1254.89 118.8C1221.77 116.88 1201.37 112.08 1189.85 103.44C1178.33 95.04 1174.49 82.08 1174.49 63.84C1174.49 24.96 1209.77 0 1280.09 0C1303.61 0 1322.57 1.92 1337.93 6.48C1368.41 14.88 1385.69 32.4 1394.09 60.48H1294.01C1292.81 56.88 1288.73 55.2 1278.65 55.2C1270.97 55.2 1269.53 56.4 1269.53 58.08C1269.53 59.04 1270.01 59.52 1275.53 60.24C1281.05 60.96 1291.85 61.68 1313.45 62.64C1333.13 63.6 1348.73 66 1360.97 69.84C1385.45 77.76 1396.01 92.64 1396.01 119.04C1396.01 161.76 1357.61 184.32 1284.17 184.32Z"
        fill="white"
      />
      <path
        d="M1068.84 183.84C1029 183.84 1004.28 176.88 989.4 162.48C974.52 147.6 969.24 125.28 969.24 93.12V6.47998H1065.72V93.36C1065.72 100.32 1066.68 102 1070.28 102C1073.4 102 1074.36 100.32 1074.36 93.36V6.47998H1169.88V93.12C1169.88 114.24 1166.52 131.28 1159.8 144.72C1146.36 171.84 1117.8 183.84 1068.84 183.84Z"
        fill="white"
      />
      <path
        d="M852.92 183.84C826.76 183.84 805.88 180.48 789.8 174C757.4 160.56 743 133.92 743 93.1202V92.8802C743 35.5202 780.92 1.68018 855.56 1.68018C880.04 1.68018 899.72 5.28017 915.8 12.7202C948.2 27.6002 964.04 55.2002 964.04 93.1202V93.3602C964.04 155.52 930.2 183.84 852.92 183.84ZM853.4 103.44C862.04 103.44 865.88 100.56 865.88 93.1202C865.88 86.1602 862.04 82.8002 853.64 82.8002C845.24 82.8002 841.16 86.1602 841.16 93.1202C841.16 100.56 845.48 103.44 853.4 103.44Z"
        fill="white"
      />
      <path d="M0 70H714.5V147.04H0V70Z" fill="white" />
      <path
        d="M1163.75 760C1109.07 760 1065.43 749.412 1031.82 728.993C964.098 686.643 934 602.698 934 474.134V473.378C934 292.632 1013.26 186 1169.26 186C1220.43 186 1261.56 197.344 1295.17 220.788C1362.89 267.676 1396 354.646 1396 474.134V474.891C1396 670.761 1325.27 760 1163.75 760ZM1164.75 506.653C1182.81 506.653 1190.83 497.578 1190.83 474.134C1190.83 452.203 1182.81 441.615 1165.25 441.615C1147.69 441.615 1139.17 452.203 1139.17 474.134C1139.17 497.578 1148.2 506.653 1164.75 506.653Z"
        fill="white"
      />
      <path d="M829.611 212.48H929.211V385.28H829.611V212.48Z" fill="white" />
      <path
        d="M617.033 385.28V212.48H724.553C744.473 212.48 761.513 215.84 776.633 222.56C806.873 235.76 824.393 261.44 824.393 298.4C824.153 354.56 789.353 385.28 725.273 385.28H617.033ZM709.673 289.28V308.96H718.553C727.913 308.96 731.033 305.84 731.033 298.88C730.793 291.44 727.193 289.28 716.873 289.28H709.673Z"
        fill="white"
      />
      <path
        d="M507.793 389.84C467.953 389.84 443.233 382.88 428.353 368.48C413.473 353.6 408.193 331.28 408.193 299.12V212.48H504.673V299.36C504.673 306.32 505.633 308 509.233 308C512.353 308 513.313 306.32 513.313 299.36V212.48H608.833V299.12C608.833 320.24 605.473 337.28 598.753 350.72C585.313 377.84 556.753 389.84 507.793 389.84Z"
        fill="white"
      />
      <path
        d="M363.689 289.76V758.5H259.289V289.76H221.609V212.48H401.369V289.76H363.689Z"
        fill="white"
      />
      <path
        d="M113.28 390.32C70.56 390.32 43.44 384.8 26.64 374.24C9.60001 363.68 2.64 347.84 0 326.96H102.24C102.96 330.08 108.96 331.76 118.56 331.76C126 331.76 128.4 331.28 128.4 329.36C128.4 328.16 127.44 327.68 121.68 326.96C115.92 326.72 104.88 326 84 324.8C50.88 322.88 30.48 318.08 18.96 309.44C7.44002 301.04 3.60004 288.08 3.60004 269.84C3.60004 230.96 38.88 206 109.2 206C132.72 206 151.68 207.92 167.04 212.48C197.52 220.88 214.8 238.4 223.2 266.48H123.12C121.92 262.88 117.84 261.2 107.76 261.2C100.08 261.2 98.64 262.4 98.64 264.08C98.64 265.04 99.12 265.52 104.64 266.24C110.16 266.96 120.96 267.68 142.56 268.64C162.24 269.6 177.84 272 190.08 275.84C214.56 283.76 225.12 298.64 225.12 325.04C225.12 367.76 186.72 390.32 113.28 390.32Z"
        fill="white"
      />
    </svg>
  );
};

const SafeKidsSvg = () => {
  return (
    <svg
      width="1396"
      height="760"
      viewBox="0 0 1396 760"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1243.98 760C1185.91 760 1149.05 743.559 1126.21 712.105C1103.05 680.652 1093.59 633.473 1090 571.281H1228.97C1229.95 580.574 1238.11 585.578 1251.16 585.578C1261.27 585.578 1264.53 584.148 1264.53 578.43C1264.53 574.855 1263.23 573.426 1255.4 571.281C1247.57 570.566 1232.56 568.422 1204.18 564.848C1159.16 559.129 1131.43 544.832 1115.77 519.098C1100.11 494.078 1094.89 455.477 1094.89 401.148C1094.89 285.344 1142.85 211 1238.43 211C1270.4 211 1296.17 216.719 1317.05 230.301C1358.48 255.32 1381.97 307.504 1393.39 391.141H1257.35C1255.72 380.418 1250.18 375.414 1236.48 375.414C1226.04 375.414 1224.08 378.988 1224.08 383.992C1224.08 386.852 1224.73 388.281 1232.23 390.426C1239.74 392.57 1254.42 394.715 1283.78 397.574C1310.53 400.434 1331.73 407.582 1348.37 419.02C1381.65 442.609 1396 486.93 1396 565.563C1396 692.805 1343.8 760 1243.98 760Z"
        fill="white"
      />
      <path
        d="M361 760V211H730.704C799.198 211 857.789 221.675 909.779 243.025C1013.76 284.963 1074 366.55 1074 483.975C1073.17 662.4 953.516 760 733.179 760H361ZM679.539 455V517.525H710.073C742.257 517.525 752.985 507.613 752.985 485.5C752.16 461.863 739.781 455 704.296 455H679.539Z"
        fill="white"
      />
      <path d="M241 211H341V760H241V211Z" fill="white" />
      <path
        d="M108.758 522.1L95.5532 624.275V760H0V211H95.5532V323.088L85.7098 462.625L101.555 326.138L121.242 211H228.319L181.743 439.75L179.582 444.325L182.944 457.288L230 760H119.802L102.516 615.887L108.758 522.1Z"
        fill="white"
      />
      <path
        d="M1395.5 179.28H630.158V6.47998H1395.5V69.84H720.878V76.08H1395.5V106.32H720.878V112.8H1395.5V179.28Z"
        fill="white"
      />
      <path
        d="M540.511 139.44V179.28H445.471V6.47998H622.111V78.72H540.511V85.92H622.111V139.44H540.511Z"
        fill="white"
      />
      <path
        d="M351.152 165.6H310.832L307.472 179.28H212.672L269.312 6.47998H394.112L449.552 179.28H354.512L351.152 165.6ZM325.232 108.72H337.712L333.872 92.88L331.472 61.44L329.072 92.88L325.232 108.72Z"
        fill="white"
      />
      <path
        d="M113.28 184.32C70.56 184.32 43.44 178.8 26.64 168.24C9.6 157.68 2.64 141.84 0 120.96H102.24C102.96 124.08 108.96 125.76 118.56 125.76C126 125.76 128.4 125.28 128.4 123.36C128.4 122.16 127.44 121.68 121.68 120.96C115.92 120.72 104.88 120 84 118.8C50.88 116.88 30.48 112.08 18.96 103.44C7.44 95.04 3.6 82.08 3.6 63.84C3.6 24.96 38.88 0 109.2 0C132.72 0 151.68 1.92 167.04 6.48C197.52 14.88 214.8 32.4 223.2 60.48H123.12C121.92 56.88 117.84 55.2 107.76 55.2C100.08 55.2 98.64 56.4 98.64 58.08C98.64 59.04 99.12 59.52 104.64 60.24C110.16 60.96 120.96 61.68 142.56 62.64C162.24 63.6 177.84 66 190.08 69.84C214.56 77.76 225.12 92.64 225.12 119.04C225.12 161.76 186.72 184.32 113.28 184.32Z"
        fill="white"
      />
    </svg>
  );
};

const AremasSvg = () => {
  return (
    <svg
      width="1392"
      height="744"
      viewBox="0 0 1392 744"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1260.84 744C1210.75 744 1178.94 721.719 1159.24 679.094C1139.26 636.469 1131.1 572.531 1128 488.25H1247.9C1248.74 500.844 1255.78 507.625 1267.04 507.625C1275.76 507.625 1278.58 505.687 1278.58 497.937C1278.58 493.094 1277.45 491.156 1270.7 488.25C1263.94 487.281 1250.99 484.375 1226.51 479.531C1187.67 471.781 1163.74 452.406 1150.23 417.531C1136.73 383.625 1132.22 331.312 1132.22 257.687C1132.22 100.75 1173.59 0 1256.06 0C1283.64 0 1305.88 7.75002 1323.89 26.1563C1359.63 60.0625 1379.9 130.781 1389.75 244.125H1272.38C1270.98 229.594 1266.19 222.813 1254.37 222.813C1245.36 222.813 1243.68 227.656 1243.68 234.438C1243.68 238.312 1244.24 240.25 1250.71 243.156C1257.19 246.062 1269.85 248.969 1295.18 252.844C1318.26 256.719 1336.55 266.406 1350.91 281.906C1379.62 313.875 1392 373.937 1392 480.5C1392 652.937 1346.97 744 1260.84 744Z"
        fill="white"
      />
      <path
        d="M1032.55 362.808H992.21L988.848 394H894L950.669 0H1075.53L1131 394H1035.91L1032.55 362.808ZM1006.62 233.117H1019.1L1015.26 197L1012.86 125.314L1010.46 197L1006.62 233.117Z"
        fill="white"
      />
      <path
        d="M722.063 676H637V0H754.411L760.161 187.778L761.359 387.761L763.276 187.778L769.746 0H885V676H799.218V533.289L812.637 192.472L787.717 676H733.564L709.603 190.594L722.063 535.167V676Z"
        fill="white"
      />
      <path
        d="M628 486H451V0H628V178.2H541.905V195.75H628V280.8H541.905V299.025H628V486Z"
        fill="white"
      />
      <path
        d="M328.756 540.433V744H233V0H346.95C368.734 0 386.689 8.26669 401.531 21.7C430.976 51.6667 445.818 116.767 445.818 234.567C445.818 280.033 442.946 315.167 436.961 339.967C425.47 388.533 404.164 405.067 376.874 410.233C404.404 410.233 421.161 420.567 430.737 450.533C440.073 482.567 443.185 538.367 443.185 633.433V676.833C443.185 713 447.255 732.633 453 744H344.317C339.289 732.633 337.374 711.967 337.374 694.4V566.267C337.374 544.567 335.459 540.433 329.714 540.433H328.756ZM328.756 290.367V359.6H335.22C340.965 359.6 343.598 347.2 343.598 323.433C343.598 301.733 340.965 290.367 335.22 290.367H328.756Z"
        fill="white"
      />
      <path
        d="M138.48 159.12H98.16L94.8 172.8H0L56.64 0H181.44L236.88 172.8H141.84L138.48 159.12ZM112.56 102.24H125.04L121.2 86.4L118.8 54.96L116.4 86.4L112.56 102.24Z"
        fill="white"
      />
    </svg>
  );
};

const MoveOnSvg = () => {
  return (
    <svg
      width="1384"
      height="741"
      viewBox="0 0 1384 741"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M973.509 722H677V202H1018.95L1149.87 521.944L1090.57 336.333V202H1384V722H1048.21L911.897 384L973.509 578.278V722Z"
        fill="white"
      />
      <path
        d="M521.327 384C491.976 384 468.549 380.643 450.508 374.169C414.156 360.74 398 334.124 398 293.36V293.12C398 235.81 440.545 202 524.289 202C551.755 202 573.835 205.597 591.876 213.03C628.228 227.897 646 255.473 646 293.36V293.599C646 355.705 608.033 384 521.327 384ZM521.865 303.671C531.559 303.671 535.868 300.793 535.868 293.36C535.868 286.406 531.559 283.049 522.135 283.049C512.71 283.049 508.132 286.406 508.132 293.36C508.132 300.793 512.979 303.671 521.865 303.671Z"
        fill="white"
      />
      <path
        d="M1383.5 177.6H677.109V4.7998H1383.5V68.1598H767.829V74.3998H1383.5V104.64H767.829V111.12H1383.5V177.6Z"
        fill="white"
      />
      <path
        d="M511.854 177.6L458.574 4.7998H557.214L569.214 55.1998L571.374 98.6398L573.774 54.9598L586.494 4.7998H682.734L627.774 177.6H511.854Z"
        fill="white"
      />
      <path
        d="M363.67 182.16C337.51 182.16 316.63 178.8 300.55 172.32C268.15 158.88 253.75 132.24 253.75 91.44V91.2C253.75 33.84 291.67 0 366.31 0C390.79 0 410.47 3.6 426.55 11.04C458.95 25.92 474.79 53.52 474.79 91.44V91.68C474.79 153.84 440.95 182.16 363.67 182.16ZM364.15 101.76C372.79 101.76 376.63 98.88 376.63 91.44C376.63 84.48 372.79 81.12 364.39 81.12C355.99 81.12 351.91 84.48 351.91 91.44C351.91 98.88 356.23 101.76 364.15 101.76Z"
        fill="white"
      />
      <path
        d="M85.0628 741H0V5H117.411L123.161 209.444L124.359 427.178L126.276 209.444L132.746 5H248V741H162.218V585.622L175.637 214.556L150.717 741H96.5642L72.6029 212.511L85.0628 587.667V741Z"
        fill="white"
      />
    </svg>
  );
};

const KubraSvg = () => {
  return (
    <svg
      width="1393"
      height="744"
      viewBox="0 0 1393 744"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M994.121 741H706V202H1038.27L1165.5 533.635L1107.87 341.242V202H1393V741H1066.71L934.252 390.65L994.121 592.026V741Z"
        fill="white"
      />
      <path d="M597 202H697V741H597V202Z" fill="white" />
      <path
        d="M552.279 645V740.52H447.879V645H410.199V201.8H589.959V645H552.279Z"
        fill="white"
      />
      <path
        d="M402.89 374.6H226.25V201.8H402.89V265.16H316.97V271.4H402.89V301.64H316.97V308.12H402.89V374.6Z"
        fill="white"
      />
      <path
        d="M222 480.229C221.04 661.121 185.76 744 109.92 744C83.76 744 62.88 733.91 46.8 714.452C14.4 674.094 0 594.098 0 471.581V470.86C0 298.617 37.92 197 112.56 197C183.84 197 220.8 296.454 222 461.491H122.16C121.2 447.078 117.36 440.592 110.64 440.592C102.24 440.592 98.16 450.681 98.16 471.581C98.16 493.922 102.48 502.571 110.4 502.571C117.36 502.571 121.2 494.643 122.16 480.229H222Z"
        fill="white"
      />
      <path
        d="M1291.04 155.621H1251.72L1248.45 169H1156L1211.23 0H1332.94L1387 169H1294.32L1291.04 155.621ZM1265.77 99.9917H1277.94L1274.19 84.5L1271.85 53.7514L1269.51 84.5L1265.77 99.9917Z"
        fill="white"
      />
      <path
        d="M861.768 122.76V169H635V0H904.854C956.444 0 998.963 1.87778 1034.11 4.92916C1103.84 11.7361 1138.99 26.5236 1138.99 53.2819C1138.99 63.6097 1132.19 71.5903 1118.02 77.2236C1090.8 88.2555 1040.35 92.0111 975.719 93.1847C1040.92 93.1847 1080.6 95.5319 1103.28 102.339C1125.39 109.615 1132.76 122.29 1132.76 143.885V153.743C1132.76 161.958 1142.39 166.418 1156 169H898.618C886.713 166.418 882.177 161.724 882.177 157.733V128.628C882.177 123.699 877.642 122.76 864.036 122.76H861.768ZM861.768 65.9569V81.6833H877.075C890.681 81.6833 896.917 78.8667 896.917 73.4681C896.917 68.5389 890.681 65.9569 877.075 65.9569H861.768Z"
        fill="white"
      />
      <path
        d="M420 169V0H541.307C561.955 0 578.145 1.64305 590.816 4.69444C615.922 11.0319 626.48 23.7069 626.48 43.4236C626.48 50.7 624.838 57.0375 622.022 61.9667C615.687 72.7639 601.609 79.1014 573.218 82.1528C587.765 83.3264 598.793 85.4389 607.006 88.4903C623.665 94.3583 630 104.686 630 121.117C630 132.383 626.48 141.303 619.207 148.579C604.659 162.662 578.145 169 541.777 169H420ZM511.508 59.6194V68.7736H523.006C526.76 68.7736 528.402 67.1306 528.402 64.0792C528.402 61.0278 526.76 59.6194 523.24 59.6194H511.508ZM511.508 98.3486V107.503H525.117C529.575 107.503 530.514 105.86 530.514 102.808C530.514 99.7569 528.637 98.3486 524.883 98.3486H511.508Z"
        fill="white"
      />
      <path
        d="M313.297 173C274.378 173 250.23 166.211 235.694 152.165C221.158 137.651 216 115.88 216 84.5102V0H310.249V84.7443C310.249 91.5332 311.187 93.1719 314.703 93.1719C317.751 93.1719 318.689 91.5332 318.689 84.7443V0H412V84.5102C412 105.111 408.718 121.732 402.153 134.842C389.024 161.295 361.124 173 313.297 173Z"
        fill="white"
      />
      <path
        d="M105.921 95.7667L93.0605 127.219V169H0V0H93.0605V34.5042L83.4739 77.4583L98.906 35.4431L118.079 0H222.363L177.002 70.4167L174.898 71.825L178.171 75.8153L224 169H116.676L99.8413 124.637L105.921 95.7667Z"
        fill="white"
      />
    </svg>
  );
};

const ContactSvg = ({ mobile }) => {
  return mobile ? (
    <svg
      width="359"
      height="548"
      viewBox="0 0 359 548"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152.5 64.6958L152.508 64.1878H152H84.0908H83.6815L83.6007 64.589C83.2985 66.0889 82.5541 67.2229 81.3518 67.9942C80.1342 68.7752 78.4033 69.2115 76.0919 69.2115C73.4417 69.2115 71.4967 68.7299 70.2193 67.7191C68.967 66.7281 68.2665 65.1544 68.2665 62.7431C68.2665 60.4948 68.9259 58.916 70.1853 57.8832C71.4648 56.8339 73.4505 56.2747 76.2551 56.2747C78.4977 56.2747 80.1913 56.6343 81.3883 57.3398C82.5624 58.0319 83.3 59.0805 83.6007 60.5731L83.6815 60.9743H84.0908H152H152.511L152.5 60.4633C152.089 41.7903 145.553 26.7731 132.973 16.4344C120.406 6.10621 101.872 0.5 77.5611 0.5C52.1108 0.5 32.8402 6.22624 19.9241 16.8806C6.99292 27.5475 0.5 43.097 0.5 62.581V62.7431C0.5 76.5735 2.9581 88.0518 8.21827 97.226C13.4833 106.409 21.5333 113.244 32.642 117.818L32.6467 117.82C43.6634 122.227 57.9346 124.5 75.7654 124.5C101.602 124.5 120.631 119.836 133.289 109.992C145.972 100.128 152.172 85.1347 152.5 64.6958Z"
        stroke="white"
      />
      <path
        d="M203.135 117.832L203.139 117.834C217.39 122.229 235.865 124.5 258.971 124.5C293.085 124.5 317.71 119.72 333.817 109.616C349.973 99.4816 357.5 84.0319 357.5 62.9051V62.7431C357.5 49.8449 353.978 38.673 346.835 29.4585C339.696 20.2485 328.967 13.0299 314.609 7.98303C300.352 2.93412 282.93 0.5 261.3 0.5C228.331 0.5 203.397 6.218 186.689 16.8444C169.95 27.4901 161.5 43.0446 161.5 62.581V62.7431C161.5 76.5955 164.695 88.0931 171.523 97.2756C178.351 106.457 188.774 113.273 203.135 117.832ZM269.904 62.7431C269.904 65.1229 269.115 66.6828 267.494 67.686C265.819 68.7232 263.186 69.2115 259.394 69.2115C255.928 69.2115 253.342 68.7255 251.635 67.6843C249.976 66.6719 249.096 65.1027 249.096 62.7431C249.096 60.5454 249.924 58.9723 251.589 57.9192C253.296 56.8399 255.934 56.2747 259.606 56.2747C263.278 56.2747 265.86 56.8403 267.511 57.9155C269.12 58.9634 269.904 60.5339 269.904 62.7431Z"
        stroke="white"
      />
      <path
        d="M150.303 238.5H150.803V238V210.637V210.456L150.686 210.316L125.024 179.721L187.577 238.365L187.722 238.5H187.919H357H357.5V238V139V138.5H357H209.248H208.748V139V164.575V164.758L208.866 164.898L233.5 194.049L173.522 138.633L173.379 138.5H173.183H1H0.5V139V238V238.5H1H150.303Z"
        stroke="white"
      />
      <path
        d="M42.1001 298.5H42.6001V298V273.625H53H53.5V273.125V253V252.5H53H1H0.5V253V273.125V273.625H1H11.3999V298V298.5H11.8999H42.1001Z"
        stroke="white"
      />
      <path
        d="M153.051 298.5H153.258L153.405 298.353L156.805 294.937H198.942L202.342 298.353L202.488 298.5H202.696H303H304.47L303.305 297.604L244.794 252.604L244.659 252.5H244.489H112.777H112.61L112.476 252.601L52.6993 297.601L51.5045 298.5H53H153.051ZM180.435 275.648L180.471 275.764L180.556 275.85L183.773 279.125H172.987L176.204 275.85L176.289 275.764L176.325 275.648L178.38 269.004L180.435 275.648Z"
        stroke="white"
      />
      <path
        d="M357.5 276.308L357.507 275.8H357H334.963H334.545L334.471 276.212C334.384 276.701 334.177 277.036 333.869 277.259C333.551 277.489 333.07 277.638 332.368 277.638C331.547 277.638 331.018 277.469 330.694 277.18C330.382 276.901 330.166 276.426 330.166 275.589C330.166 274.813 330.368 274.332 330.687 274.037C331.015 273.734 331.557 273.54 332.421 273.54C333.111 273.54 333.582 273.665 333.892 273.871C334.183 274.065 334.385 274.364 334.471 274.847L334.545 275.259H334.963H357H357.51L357.5 274.749C357.366 267.862 355.226 262.279 351.063 258.421C346.903 254.568 340.794 252.5 332.844 252.5C324.528 252.5 318.178 254.61 313.904 258.585C309.624 262.565 307.5 268.346 307.5 275.53V275.589C307.5 280.676 308.301 284.927 310.037 288.34C311.779 291.764 314.446 294.317 318.119 296.023L318.119 296.023L318.124 296.025C321.759 297.665 326.445 298.5 332.262 298.5C340.686 298.5 346.961 296.787 351.158 293.107C355.368 289.416 357.393 283.831 357.5 276.308Z"
        stroke="white"
      />
      <path
        d="M333.959 547.5H334.459V547V418.15H357H357.5V417.65V313V312.5H357H1H0.5V313V417.65V418.15H1H23.5407V547V547.5H24.0407H333.959Z"
        stroke="white"
      />
    </svg>
  ) : (
    <svg
      width="1346"
      height="571"
      viewBox="0 0 1346 571"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1285.91 565.5H1286.41V565V473.739H1345H1345.5V473.239V399V398.5H1345H432H431.5V399V473.239V473.739H432H490.59V565V565.5H491.09H1285.91Z"
        stroke="white"
      />
      <path
        d="M429.5 485.621L429.508 485.113H429H333.208H332.798L332.717 485.515C332.281 487.701 331.2 489.366 329.453 490.496C327.691 491.636 325.207 492.26 321.924 492.26C318.169 492.26 315.37 491.573 313.515 490.093C311.684 488.631 310.681 486.321 310.681 482.846C310.681 479.603 311.626 477.287 313.464 475.767C315.321 474.23 318.178 473.431 322.155 473.431C325.335 473.431 327.765 473.945 329.498 474.975C331.208 475.992 332.282 477.537 332.717 479.716L332.798 480.118H333.208H429H429.511L429.5 479.607C428.922 453.091 419.722 431.788 402.032 417.124C384.354 402.47 358.262 394.5 323.997 394.5C288.123 394.5 260.993 402.642 242.823 417.759C224.639 432.888 215.5 454.946 215.5 482.615V482.846C215.5 502.499 218.963 518.79 226.359 531.8C233.76 544.819 245.077 554.515 260.711 561.009L260.716 561.01C276.224 567.268 296.327 570.5 321.464 570.5C357.891 570.5 384.679 563.866 402.482 549.902C420.309 535.918 429.038 514.656 429.5 485.621Z"
        stroke="white"
      />
      <path
        d="M94.2462 565.5H94.6381L94.7318 565.119L97.8721 552.358H135.897L139.037 565.119L139.131 565.5H139.523H231H231.686L231.476 564.847L178.114 398.847L178.003 398.5H177.638H57.5167H57.1547L57.0417 398.844L2.52496 564.844L2.30952 565.5H3H94.2462ZM119.158 482.038L119.161 482.079L119.171 482.118L122.717 496.717H111.976L115.522 482.118L115.532 482.079L115.535 482.038L117.347 458.354L119.158 482.038Z"
        stroke="white"
      />
      <path
        d="M1312.72 369.5H1313.22V369V277.186H1345H1345.5V276.686V202V201.5H1345H1191H1190.5V202V276.686V277.186H1191H1222.78V369V369.5H1223.28H1312.72Z"
        stroke="white"
      />
      <path
        d="M494.106 369.5H494.606V369V322.843V322.563L494.367 322.416L400.791 265.203L617.622 369.451L617.725 369.5H617.839H1174H1174.5V369V202V201.5H1174H687.997H687.497V202V245.142V245.423L687.737 245.569L777.664 300.145L569.58 201.548L569.478 201.5H569.366H3H2.5V202V369V369.5H3H494.106Z"
        stroke="white"
      />
      <path
        d="M395.219 167.043L395.221 167.044C450.316 173.272 521.845 176.5 611.445 176.5C743.782 176.5 838.969 169.699 901.083 155.419C932.137 148.28 954.971 139.262 970.051 128.255C985.15 117.235 992.5 104.2 992.5 89.0764V88.8459C992.5 70.3327 978.706 54.4684 951.22 41.4735C923.717 28.4707 882.354 18.26 826.856 11.1102C771.757 3.95887 704.335 0.5 620.487 0.5C492.663 0.5 396.247 8.62749 331.772 23.6562C299.538 31.1697 275.249 40.4165 259.008 51.262C242.762 62.1106 234.5 74.6094 234.5 88.6153V88.8459C234.5 108.712 247.02 125.046 273.307 138.002C299.585 150.952 339.723 160.586 395.219 167.043ZM655.33 88.8459C655.33 90.448 654.605 91.8221 653.013 93.0096C651.4 94.2128 648.911 95.2093 645.445 95.9958C638.517 97.5675 627.881 98.2602 613.089 98.2602C599.533 98.2602 589.1 97.5679 582.067 95.9954C578.548 95.2085 575.925 94.2103 574.192 93.0004C572.475 91.8014 571.67 90.4259 571.67 88.8459C571.67 87.3816 572.423 86.0628 574.092 84.8843C575.774 83.6959 578.347 82.6838 581.866 81.8684C588.897 80.2389 599.535 79.4315 613.911 79.4315C628.287 79.4315 638.718 80.2391 645.542 81.8676C648.957 82.6825 651.424 83.6932 653.028 84.8781C654.616 86.0507 655.33 87.3694 655.33 88.8459Z"
        stroke="white"
      />
      <path
        d="M215.5 91.6207L215.508 91.1127H215H118.758H118.348L118.268 91.5143C117.829 93.6999 116.744 95.3647 114.988 96.4953C113.217 97.6357 110.72 98.2602 107.422 98.2602C103.648 98.2602 100.835 97.5732 98.9702 96.0919C97.1301 94.6301 96.1227 92.3198 96.1227 88.8459C96.1227 85.6035 97.072 83.288 98.9192 81.7673C100.786 80.2303 103.657 79.4315 107.653 79.4315C110.849 79.4315 113.291 79.9452 115.033 80.9758C116.752 81.9929 117.83 83.5381 118.268 85.7163L118.348 86.1179H118.758H215H215.511L215.5 85.607C214.919 59.0901 205.676 37.7871 187.903 23.1234C170.143 8.47004 143.929 0.5 109.504 0.5C73.4623 0.5 46.2057 8.64144 27.9516 23.758C9.68271 38.8869 0.5 60.9449 0.5 88.6153V88.8459C0.5 108.499 3.97962 124.79 11.4104 137.801C18.8461 150.82 30.2162 160.516 45.9225 167.009L45.9272 167.011C61.5073 173.268 81.7042 176.5 106.959 176.5C143.557 176.5 170.47 169.866 188.355 155.903C206.266 141.919 215.036 120.657 215.5 91.6207Z"
        stroke="white"
      />
    </svg>
  );
};

const InstagramIcon = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_118_294)">
        <path
          d="M17.9861 3.15137C22.7918 3.15137 23.3609 3.17187 25.2508 3.25391C27.0073 3.3291 27.9558 3.61621 28.5881 3.85547C29.4242 4.16992 30.0284 4.55273 30.6537 5.16113C31.286 5.77637 31.6724 6.35742 31.9956 7.1709C32.2415 7.78613 32.5366 8.71582 32.6139 10.418C32.6982 12.2637 32.7193 12.8174 32.7193 17.4863C32.7193 22.1621 32.6982 22.7158 32.6139 24.5547C32.5366 26.2637 32.2415 27.1865 31.9956 27.8018C31.6724 28.6152 31.279 29.2031 30.6537 29.8115C30.0213 30.4268 29.4242 30.8027 28.5881 31.1172C27.9558 31.3564 27.0002 31.6436 25.2508 31.7188C23.3538 31.8008 22.7847 31.8213 17.9861 31.8213C13.1804 31.8213 12.6114 31.8008 10.7214 31.7188C8.96495 31.6436 8.01647 31.3564 7.38414 31.1172C6.54807 30.8027 5.94385 30.4199 5.31855 29.8115C4.68622 29.1963 4.2998 28.6152 3.97662 27.8018C3.73071 27.1865 3.43563 26.2568 3.35834 24.5547C3.27403 22.709 3.25296 22.1553 3.25296 17.4863C3.25296 12.8105 3.27403 12.2568 3.35834 10.418C3.43563 8.70898 3.73071 7.78613 3.97662 7.1709C4.2998 6.35742 4.69325 5.76953 5.31855 5.16113C5.95087 4.5459 6.54807 4.16992 7.38414 3.85547C8.01647 3.61621 8.97198 3.3291 10.7214 3.25391C12.6114 3.17187 13.1804 3.15137 17.9861 3.15137ZM17.9861 0C13.1032 0 12.4919 0.0205078 10.5739 0.102539C8.66284 0.18457 7.34901 0.485351 6.21083 0.916016C5.02346 1.36719 4.01877 1.96191 3.0211 2.93945C2.01641 3.91016 1.40516 4.8877 0.94146 6.03613C0.498834 7.15039 0.189697 8.42188 0.105387 10.2812C0.0210775 12.1543 0 12.749 0 17.5C0 22.251 0.0210775 22.8457 0.105387 24.7119C0.189697 26.5713 0.498834 27.8496 0.94146 28.957C1.40516 30.1123 2.01641 31.0898 3.0211 32.0605C4.01877 33.0312 5.02346 33.6328 6.2038 34.0771C7.34901 34.5078 8.65582 34.8086 10.5668 34.8906C12.4849 34.9727 13.0961 34.9932 17.9791 34.9932C22.862 34.9932 23.4733 34.9727 25.3913 34.8906C27.3024 34.8086 28.6162 34.5078 29.7544 34.0771C30.9347 33.6328 31.9394 33.0312 32.9371 32.0605C33.9347 31.0898 34.553 30.1123 35.0097 28.9639C35.4523 27.8496 35.7614 26.5781 35.8458 24.7188C35.9301 22.8525 35.9511 22.2578 35.9511 17.5068C35.9511 12.7559 35.9301 12.1611 35.8458 10.2949C35.7614 8.43555 35.4523 7.15723 35.0097 6.0498C34.5671 4.8877 33.9558 3.91016 32.9511 2.93945C31.9535 1.96875 30.9488 1.36719 29.7684 0.922852C28.6232 0.492187 27.3164 0.191406 25.4054 0.109375C23.4803 0.0205078 22.8691 0 17.9861 0Z"
          fill="white"
        />
        <path
          d="M17.8727 8.40002C12.772 8.40002 8.63379 12.4264 8.63379 17.3893C8.63379 22.3522 12.772 26.3785 17.8727 26.3785C22.9735 26.3785 27.1117 22.3522 27.1117 17.3893C27.1117 12.4264 22.9735 8.40002 17.8727 8.40002ZM17.8727 23.2203C14.5636 23.2203 11.8797 20.609 11.8797 17.3893C11.8797 14.1696 14.5636 11.5582 17.8727 11.5582C21.1819 11.5582 23.8658 14.1696 23.8658 17.3893C23.8658 20.609 21.1819 23.2203 17.8727 23.2203Z"
          fill="white"
        />
        <path
          d="M29.7474 8.15522C29.7474 9.31733 28.7779 10.2539 27.5905 10.2539C26.3961 10.2539 25.4336 9.31049 25.4336 8.15522C25.4336 6.9931 26.4032 6.05658 27.5905 6.05658C28.7779 6.05658 29.7474 6.99994 29.7474 8.15522Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_118_294">
          <rect width="35.9722" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const GithubIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_118_300)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.5006 0.729187C13.3462 0.731343 9.32794 2.20277 6.16443 4.88037C3.00093 7.55796 0.898441 11.2671 0.232918 15.3446C-0.432605 19.4221 0.382226 23.602 2.53173 27.1369C4.68123 30.6719 8.02522 33.3313 11.9658 34.6398C12.8351 34.8011 13.1626 34.2623 13.1626 33.8042C13.1626 33.346 13.1452 32.0177 13.1394 30.5655C8.27103 31.6172 7.24231 28.5111 7.24231 28.5111C6.44831 26.4942 5.30076 25.964 5.30076 25.964C3.71275 24.8864 5.41958 24.9066 5.41958 24.9066C7.17857 25.0305 8.10298 26.7017 8.10298 26.7017C9.66201 29.3611 12.1976 28.5918 13.1944 28.1423C13.3509 27.0157 13.8059 26.2493 14.3072 25.8142C10.4183 25.3762 6.33239 23.8837 6.33239 17.2163C6.30828 15.4871 6.95361 13.8149 8.13485 12.5456C7.95518 12.1076 7.35532 10.3385 8.30581 7.93544C8.30581 7.93544 9.77502 7.46866 13.1191 9.719C15.9875 8.93905 19.0138 8.93905 21.8822 9.719C25.2234 7.46866 26.6896 7.93544 26.6896 7.93544C27.643 10.3327 27.0432 12.1019 26.8635 12.5456C28.0485 13.8151 28.6952 15.4902 28.6689 17.222C28.6689 23.9039 24.5742 25.3762 20.6795 25.8056C21.3055 26.3473 21.8648 27.4047 21.8648 29.0298C21.8648 31.3579 21.8445 33.2308 21.8445 33.8042C21.8445 34.2681 22.1603 34.8098 23.0471 34.6398C26.9881 33.3312 30.3324 30.6713 32.4819 27.1357C34.6313 23.6002 35.4457 19.4196 34.7795 15.3418C34.1132 11.2639 32.0097 7.5547 28.8451 4.87757C25.6805 2.20044 21.6614 0.729976 17.5064 0.729187H17.5006Z"
          fill="white"
        />
        <path
          d="M6.62752 25.7134C6.58985 25.7998 6.45075 25.8257 6.33774 25.7652C6.22472 25.7047 6.14069 25.5923 6.18126 25.503C6.22183 25.4137 6.35803 25.3906 6.47105 25.4512C6.58406 25.5117 6.67099 25.6269 6.62752 25.7134Z"
          fill="white"
        />
        <path
          d="M7.33737 26.4999C7.27736 26.53 7.2087 26.5384 7.14315 26.5237C7.0776 26.509 7.01924 26.472 6.97804 26.4193C6.86503 26.2982 6.84183 26.1311 6.92877 26.0562C7.0157 25.9813 7.1722 26.0159 7.28521 26.1369C7.39823 26.2579 7.42431 26.425 7.33737 26.4999Z"
          fill="white"
        />
        <path
          d="M8.02677 27.4997C7.91955 27.5747 7.73698 27.4997 7.63556 27.3499C7.60751 27.323 7.58521 27.2908 7.56997 27.2552C7.55474 27.2195 7.54688 27.1812 7.54688 27.1425C7.54688 27.1037 7.55474 27.0654 7.56997 27.0297C7.58521 26.9941 7.60751 26.9619 7.63556 26.935C7.74278 26.863 7.92535 26.935 8.02677 27.082C8.1282 27.2289 8.1311 27.4248 8.02677 27.4997Z"
          fill="white"
        />
        <path
          d="M8.96294 28.4679C8.86731 28.5745 8.67316 28.5457 8.51378 28.4016C8.3544 28.2576 8.31672 28.0616 8.41235 27.9579C8.50798 27.8542 8.70213 27.883 8.86731 28.0242C9.03249 28.1654 9.06437 28.3642 8.96294 28.4679Z"
          fill="white"
        />
        <path
          d="M10.2758 29.0326C10.2324 29.1681 10.0353 29.2286 9.83826 29.1709C9.64121 29.1133 9.5108 28.952 9.54848 28.8137C9.58615 28.6753 9.7861 28.612 9.98605 28.6753C10.186 28.7387 10.3135 28.8915 10.2758 29.0326Z"
          fill="white"
        />
        <path
          d="M11.7076 29.1306C11.7076 29.2718 11.5453 29.3928 11.3366 29.3957C11.128 29.3986 10.957 29.2833 10.957 29.1422C10.957 29.001 11.1193 28.8799 11.3279 28.8771C11.5366 28.8742 11.7076 28.9866 11.7076 29.1306Z"
          fill="white"
        />
        <path
          d="M13.0407 28.9088C13.0667 29.0499 12.9218 29.1969 12.7132 29.2315C12.5046 29.266 12.322 29.1825 12.2959 29.0442C12.2698 28.9059 12.4205 28.756 12.6234 28.7186C12.8262 28.6811 13.0146 28.7676 13.0407 28.9088Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_118_300">
          <rect width="35" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const FratelliSvg = () => {
  return (
    <svg
      width="1413"
      height="750"
      viewBox="0 0 1413 750"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M773.744 159.304H662.595L653.332 173H392L548.138 0H892.17L1045 173H783.006L773.744 159.304ZM702.291 102.358H736.694L726.108 86.5L719.493 55.0236L712.876 86.5L702.291 102.358Z"
        fill="white"
      />
      <path
        d="M280.688 125.52V172.8H184.688V0H298.927C320.767 0 338.768 1.92 353.648 5.03999C383.168 12 398.047 27.12 398.047 54.48C398.047 65.04 395.167 73.2 389.167 78.96C377.647 90.24 356.287 94.08 328.927 95.28C356.527 95.28 373.327 97.68 382.927 104.64C392.287 112.08 395.407 125.04 395.407 147.12V157.2C395.407 165.6 399.488 170.16 405.247 172.8H296.287C291.247 170.16 289.328 165.36 289.328 161.28V131.52C289.328 126.48 287.408 125.52 281.648 125.52H280.688ZM280.688 67.44V83.52H287.167C292.927 83.52 295.568 80.64 295.568 75.12C295.568 70.08 292.927 67.44 287.167 67.44H280.688Z"
        fill="white"
      />
      <path
        d="M95.04 132.96V172.8H0V0H176.64V72.24H95.04V79.44H176.64V132.96H95.04Z"
        fill="white"
      />
      <path
        d="M1163.08 78.28V173.8H1058.68V78.28H1021V1H1412.5V78.28H1163.08Z"
        fill="white"
      />
      <path
        d="M397 367.8H0V195L397 195V258.36H90.7201V264.6H397V294.84H90.7201V301.32H397V367.8Z"
        fill="white"
      />
      <path d="M405 367.8V195H505.08V283.8H563.16V367.8H405Z" fill="white" />
      <path d="M571 367.8V195H671.08V283.8H729.16V367.8H571Z" fill="white" />
      <path d="M737 195H1400.5V367.8H737V195Z" fill="white" />
      <path
        d="M0 736V390H215.185C255.052 390 289.155 396.728 319.416 410.183C379.936 436.614 415 488.033 415 562.039C414.52 674.489 344.873 736 216.626 736H0ZM185.405 543.778V583.183H203.177C221.91 583.183 228.154 576.936 228.154 563C227.674 548.103 220.469 543.778 199.815 543.778H185.405Z"
        fill="white"
      />
      <path
        d="M986.715 500H928V390H995.712L1021.64 457.681L1009.9 418.417V390H1068V500H1001.51L974.514 428.5L986.715 469.597V500Z"
        fill="white"
      />
      <path
        d="M867.69 491.292H842.158L840.03 500H780L815.866 390H894.894L930 500H869.818L867.69 491.292ZM851.277 455.083H859.179L856.748 445L855.228 424.986L853.708 445L851.277 455.083Z"
        fill="white"
      />
      <path
        d="M678.193 750H624L624 390H698.802L702.466 420.556L703.229 453.097L704.45 420.556L708.572 390H782L782 750H727.349V726.778L735.898 671.319L720.021 750H685.521L670.255 671.014L678.193 727.083V750Z"
        fill="white"
      />
      <path
        d="M564.275 491.292H538.572L536.431 500H476L512.105 390H591.66L627 500H566.416L564.275 491.292ZM547.752 455.083H555.707L553.259 445L551.73 424.986L550.2 445L547.752 455.083Z"
        fill="white"
      />
      <path d="M415 390H478V500H415V390Z" fill="white" />
      <path d="M1289 390H1399V750H1289V390Z" fill="white" />
      <path
        d="M1239.08 475.867V749.5H1122.92V475.867H1081V390H1281V475.867H1239.08Z"
        fill="white"
      />
    </svg>
  );
};

const MCSSvg = () => {
  return (
    <svg
      width="1378"
      height="745"
      viewBox="0 0 1378 745"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1222.24 0.399902H1378V253.326H1222.24V0.399902Z" fill="white" />
      <path
        d="M1151.89 113.514V253.326H988.625V113.514L899 113.514V0.399902H1210.82V113.514H1151.89Z"
        fill="white"
      />
      <path
        d="M728.162 253.326V0.399902H884.672V130.376H975.5V253.326H728.162Z"
        fill="white"
      />
      <path
        d="M449.105 260C344.263 260 279.211 249.797 240.053 228.687C200.895 206.874 187 174.154 187 127.009V0H440.895V127.361C440.895 137.564 443.421 140.027 452.895 140.027C461.105 140.027 463.632 137.564 463.632 127.361V0H715V127.009C715 157.97 706.158 182.95 688.474 202.652C653.105 242.409 577.947 260 449.105 260Z"
        fill="white"
      />
      <path
        d="M60.0242 253H0V0H82.8502L86.9082 70.2778L87.7536 145.124L89.1063 70.2778L93.6715 0H175V253H114.469V199.589L123.937 72.0347L106.353 253H68.1401L51.2319 71.3319L60.0242 200.292V253Z"
        fill="white"
      />
      <path
        d="M1378 514H1217V285H1378V368.967H1299.69V377.236H1378V417.311H1299.69V425.899H1378V514Z"
        fill="white"
      />
      <path
        d="M1065.73 375L1017 286H1107.21L1118.18 311.958L1120.16 334.332L1122.35 311.835L1133.99 286H1222L1171.74 375H1065.73Z"
        fill="white"
      />
      <path d="M932 285H1022V514H932V285Z" fill="white" />
      <path
        d="M890.624 325.803V375H795.377V325.803H761V286H925V325.803H890.624Z"
        fill="white"
      />
      <path
        d="M694.274 495.871H657.508L654.444 514H568L619.647 285H733.447L784 514H697.337L694.274 495.871ZM670.638 420.492H682.018L678.517 399.5L676.328 357.835L674.14 399.5L670.638 420.492Z"
        fill="white"
      />
      <path
        d="M572 375H411V286H572V318.633H493.688V321.847H572V337.422H493.688V340.76H572V375Z"
        fill="white"
      />
      <path
        d="M298.486 451.343V514H211V285H315.109C335.012 285 351.416 287.544 364.976 291.679C391.878 300.903 405.439 320.94 405.439 357.199C405.439 371.193 402.814 382.007 397.346 389.64C386.848 404.589 367.382 409.678 342.448 411.268C367.601 411.268 382.911 414.449 391.659 423.672C400.189 433.532 403.033 450.707 403.033 479.968V493.326C403.033 504.458 406.751 510.501 412 514H312.703C308.11 510.501 306.36 504.14 306.36 498.733V459.294C306.36 452.615 304.61 451.343 299.361 451.343H298.486ZM298.486 374.374V395.683H304.392C309.641 395.683 312.047 391.867 312.047 384.551C312.047 377.872 309.641 374.374 304.392 374.374H298.486Z"
        fill="white"
      />
      <path
        d="M207 403.787C206.126 483.485 174.025 520 105.017 520C81.2141 520 62.2151 515.555 47.5838 506.982C18.1027 489.2 5 453.955 5 399.976V399.659C5 323.771 39.5038 279 107.419 279C172.278 279 205.908 322.818 207 395.531H116.155C115.281 389.181 111.787 386.323 105.672 386.323C98.0292 386.323 94.3168 390.768 94.3168 399.976C94.3168 409.82 98.2476 413.63 105.454 413.63C111.787 413.63 115.281 410.137 116.155 403.787H207Z"
        fill="white"
      />
      <path
        d="M1292.05 647C1259.22 647 1238.38 643.706 1225.47 637.404C1212.38 631.102 1207.03 621.648 1205 609.187H1283.57C1284.12 611.049 1288.73 612.052 1296.11 612.052C1301.83 612.052 1303.67 611.766 1303.67 610.62C1303.67 609.904 1302.93 609.617 1298.51 609.187C1294.08 609.044 1285.6 608.615 1269.55 607.898C1244.1 606.753 1228.42 603.888 1219.57 598.732C1210.72 593.719 1207.77 585.984 1207.77 575.099C1207.77 551.896 1234.88 537 1288.92 537C1306.99 537 1321.56 538.146 1333.37 540.867C1356.79 545.88 1370.07 556.336 1376.52 573.094H1299.62C1298.69 570.945 1295.56 569.943 1287.81 569.943C1281.91 569.943 1280.8 570.659 1280.8 571.661C1280.8 572.234 1281.17 572.521 1285.41 572.951C1289.66 573.38 1297.96 573.81 1314.55 574.383C1329.68 574.956 1341.67 576.388 1351.07 578.68C1369.88 583.406 1378 592.286 1378 608.042C1378 633.536 1348.49 647 1292.05 647Z"
        fill="white"
      />
      <path
        d="M1140.29 739H1095V544H1147.24L1167.24 663.979L1158.18 594.375V544H1203V739H1151.71L1130.88 612.25L1140.29 685.104V739Z"
        fill="white"
      />
      <path
        d="M1037.71 744C1024.93 744 1014.72 740.219 1006.87 732.926C991.036 717.801 984 687.821 984 641.905V641.635C984 577.083 1002.53 539 1039 539C1050.96 539 1060.57 543.051 1068.43 551.424C1084.26 568.17 1092 599.231 1092 641.905V642.175C1092 712.129 1075.47 744 1037.71 744ZM1037.94 653.519C1042.16 653.519 1044.04 650.278 1044.04 641.905C1044.04 634.072 1042.16 630.291 1038.06 630.291C1033.95 630.291 1031.96 634.072 1031.96 641.905C1031.96 650.278 1034.07 653.519 1037.94 653.519Z"
        fill="white"
      />
      <path d="M932 544H981V739H932V544Z" fill="white" />
      <path
        d="M744.401 631.24V739.089H664.112V631.24H635.135V543.985H922.5V631.24H744.401Z"
        fill="white"
      />
      <path
        d="M552.23 744.238C521.591 744.238 502.58 736.379 491.137 720.121C479.693 703.32 475.633 678.119 475.633 641.808V543.985H549.83V642.079C549.83 649.937 550.568 651.834 553.337 651.834C555.736 651.834 556.475 649.937 556.475 642.079V543.985H629.934V641.808C629.934 665.654 627.35 684.894 622.182 700.068C611.846 730.689 589.882 744.238 552.23 744.238Z"
        fill="white"
      />
      <path
        d="M350.732 739.089V543.985H427.698V644.247H472.364V739.089H350.732Z"
        fill="white"
      />
      <path
        d="M261.539 744C241.419 744 225.36 742.008 212.993 738.166C188.075 730.198 177 714.403 177 690.213V690.071C177 656.063 206.164 636 263.569 636C282.396 636 297.532 638.134 309.899 642.545C334.818 651.368 347 667.731 347 690.213V690.356C347 727.209 320.974 744 261.539 744ZM261.908 696.332C268.553 696.332 271.506 694.625 271.506 690.213C271.506 686.087 268.553 684.095 262.092 684.095C255.632 684.095 252.494 686.087 252.494 690.213C252.494 694.625 255.817 696.332 261.908 696.332Z"
        fill="white"
      />
      <path
        d="M89.3165 744.78C56.463 744.78 35.6065 738.548 22.6865 726.625C9.58204 714.702 4.22949 696.817 2.19922 673.242H80.8263C81.38 676.765 85.9942 678.662 93.3771 678.662C99.0987 678.662 100.944 678.12 100.944 675.952C100.944 674.597 100.206 674.055 95.7765 673.242C91.3468 672.971 82.8565 672.158 66.7989 670.803C41.3282 668.635 25.6397 663.216 16.7803 653.461C7.92091 643.976 4.96778 629.344 4.96778 608.749C4.96778 564.851 32.0996 536.669 86.1788 536.669C104.267 536.669 118.848 538.837 130.66 543.986C154.101 553.47 167.39 573.251 173.85 604.956H96.8839C95.961 600.891 92.8233 598.994 85.0714 598.994C79.1651 598.994 78.0577 600.349 78.0577 602.246C78.0577 603.33 78.4268 603.872 82.672 604.685C86.9171 605.498 95.2228 606.311 111.834 607.395C126.969 608.478 138.966 611.188 148.379 615.524C167.205 624.466 175.326 641.267 175.326 671.074C175.326 719.308 145.795 744.78 89.3165 744.78Z"
        fill="white"
      />
    </svg>
  );
};

const YumacareSvg = () => {
  return (
    <svg
      width="1387"
      height="760"
      viewBox="0 0 1387 760"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1367.64 753.212H933V490.303H1367.64V586.703H1236.92V596.197H1367.64V642.206H1236.92V652.065H1367.64V753.212Z"
        fill="white"
      />
      <path
        d="M834.465 681.04V753H767V490H847.283C862.631 490 875.281 492.922 885.738 497.671C906.483 508.264 916.94 531.276 916.94 572.918C916.94 588.99 914.916 601.41 910.7 610.176C902.604 627.344 887.593 633.189 868.366 635.015C887.762 635.015 899.568 638.668 906.314 649.261C912.892 660.585 915.085 680.31 915.085 713.915V729.257C915.085 742.042 917.952 748.982 922 753H845.428C841.886 748.982 840.536 741.676 840.536 735.467V690.172C840.536 682.501 839.187 681.04 835.139 681.04H834.465ZM834.465 592.643V617.117H839.018C843.066 617.117 844.922 612.733 844.922 604.332C844.922 596.661 843.066 592.643 839.018 592.643H834.465Z"
        fill="white"
      />
      <path
        d="M623.044 732.399H561.698L556.586 753.212H255.322L341.498 490.303L688.406 490.303L772.756 753.212H628.156L623.044 732.399ZM583.607 645.858H602.595L596.753 621.758L593.101 573.923L589.45 621.758L583.607 645.858Z"
        fill="white"
      />
      <path
        d="M258 626.427C256.962 718.03 218.822 760 136.832 760C108.551 760 85.9784 754.891 68.5946 745.037C33.5676 724.599 18 684.09 18 622.047V621.682C18 534.459 58.9946 483 139.686 483C216.746 483 256.703 533.364 258 616.938H150.065C149.027 609.639 144.876 606.354 137.611 606.354C128.53 606.354 124.119 611.464 124.119 622.047C124.119 633.361 128.789 637.74 137.351 637.74C144.876 637.74 149.027 633.726 150.065 626.427H258Z"
        fill="white"
      />
      <path
        d="M1153.55 415.296H1057.89L1049.91 451H825L959.379 0H1255.47L1387 451H1161.52L1153.55 415.296ZM1092.05 266.842H1121.66L1112.55 225.5L1106.85 143.443L1101.16 225.5L1092.05 266.842Z"
        fill="white"
      />
      <path
        d="M706.106 451H655V0H725.541L728.996 125.278L729.716 258.699L730.868 125.278L734.755 0H804V451H752.462V355.789L760.524 128.41L745.552 451H713.016L698.62 127.157L706.106 357.042V451Z"
        fill="white"
      />
      <path
        d="M488.405 159C427.843 159 390.266 152.76 367.646 139.851C345.026 126.512 337 106.502 337 77.6712V0H483.663V77.8863C483.663 84.1258 485.122 85.6319 490.594 85.6319C495.337 85.6319 496.797 84.1258 496.797 77.8863V0H642V77.6712C642 96.6049 636.892 111.881 626.677 123.93C606.246 148.242 562.831 159 488.405 159Z"
        fill="white"
      />
      <path
        d="M98.8287 451V307.557L0 0H151.707L170.671 79.5514L173.953 177.894L177.6 78.925L195.469 0H349L250.171 307.557V451H98.8287Z"
        fill="white"
      />
    </svg>
  );
};

const BayetavSvg = () => {
  return (
    <svg
      width="1416"
      height="761"
      viewBox="0 0 1416 761"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1323 195H1416V757H1323V195Z" fill="white" />
      <path
        d="M1209.23 712.949V757H1120V596H1226.18C1246.48 596 1263.21 597.789 1277.04 600.696C1304.48 607.181 1318.31 621.268 1318.31 646.76C1318.31 656.599 1315.63 664.201 1310.05 669.568C1299.35 680.078 1279.49 683.656 1254.06 684.774C1279.72 684.774 1295.33 687.01 1304.25 693.494C1312.95 700.426 1315.85 712.501 1315.85 733.074V742.465C1315.85 750.292 1319.65 754.54 1325 757H1223.73C1219.04 754.54 1217.26 750.068 1217.26 746.267V718.539C1217.26 713.843 1215.47 712.949 1210.12 712.949H1209.23ZM1209.23 658.835V673.817H1215.25C1220.6 673.817 1223.06 671.133 1223.06 665.99C1223.06 661.294 1220.6 658.835 1215.25 658.835H1209.23Z"
        fill="white"
      />
      <path
        d="M1032.61 744.254H995.165L992.045 757H904L956.604 596H1072.51L1124 757H1035.73L1032.61 744.254ZM1008.54 691.258H1020.13L1016.56 676.5L1014.33 647.207L1012.11 676.5L1008.54 691.258Z"
        fill="white"
      />
      <path d="M762 757V194.5H855.018V678.736H909V757H762Z" fill="white" />
      <path d="M609 757V196H702.018V678.736H756V757H609Z" fill="white" />
      <path
        d="M507.829 761C470.697 761 447.658 754.525 433.789 741.129C419.921 727.286 415 706.521 415 676.602V596H504.921V676.825C504.921 683.3 505.816 684.863 509.171 684.863C512.079 684.863 512.974 683.3 512.974 676.825V596H602V676.602C602 696.25 598.868 712.103 592.605 724.606C580.079 749.836 553.461 761 507.829 761Z"
        fill="white"
      />
      <path
        d="M310.719 514.767L298.491 618.803V757H210V198H298.491V312.129L289.375 454.208L304.049 315.235L322.281 198H421.444L378.31 430.917L376.309 435.575L379.422 448.774L423 757H320.947L304.938 610.262L310.719 514.767Z"
        fill="white"
      />
      <path
        d="M101.944 761C77.6819 761 58.317 757.883 43.4039 751.871C13.3551 739.402 0 714.686 0 676.834V676.611C0 623.395 35.1683 592 104.392 592C127.096 592 145.347 595.34 160.261 602.242C190.309 616.047 205 641.653 205 676.834V677.057C205 734.726 173.616 761 101.944 761ZM102.389 686.408C110.402 686.408 113.963 683.736 113.963 676.834C113.963 670.377 110.402 667.26 102.611 667.26C94.8208 667.26 91.0369 670.377 91.0369 676.834C91.0369 683.736 95.0434 686.408 102.389 686.408Z"
        fill="white"
      />
      <path
        d="M1236.14 179L1181 0H1283.09L1295.51 52.2083L1297.75 97.2069L1300.23 51.9597L1313.39 0H1413L1356.12 179H1236.14Z"
        fill="white"
      />
      <path
        d="M1125.23 521.192H1083.52L1080.05 566H982L1040.58 0H1169.66L1227 566H1128.7L1125.23 521.192ZM1098.42 334.883H1111.33L1107.35 283L1104.87 180.019L1102.39 283L1098.42 334.883Z"
        fill="white"
      />
      <path
        d="M970.222 80.0528V566H862.778V80.0528H824V0H1009V80.0528H970.222Z"
        fill="white"
      />
      <path
        d="M817 179H634V0H817V65.6333H727.986V72.0972H817V103.422H727.986V110.135H817V179Z"
        fill="white"
      />
      <path
        d="M472.113 566.5V122.068L405 0H508.022L520.9 31.5736L523.129 70.6056L525.605 31.325L537.74 0H642L574.887 122.068V566.5H472.113Z"
        fill="white"
      />
      <path
        d="M309.456 164.829H248.179L243.073 179H99L185.079 0H374.745L459 179H314.562L309.456 164.829ZM270.064 105.908H289.03L283.195 89.5L279.547 56.9319L275.9 89.5L270.064 105.908Z"
        fill="white"
      />
      <path
        d="M3 179V0H58.4548C67.8939 0 75.295 1.74027 81.0872 4.97222C92.5642 11.6847 97.3911 25.1097 97.3911 45.9931C97.3911 53.7 96.6402 60.4125 95.3531 65.6333C92.457 77.0694 86.0212 83.7819 73.0425 87.0139C79.6927 88.2569 84.7341 90.4944 88.4883 93.7264C96.1039 99.9417 99 110.881 99 128.283C99 140.217 97.3911 149.664 94.0659 157.371C87.4156 172.287 75.295 179 58.6693 179H3ZM44.8324 63.1472V72.8431H50.0883C51.8045 72.8431 52.5553 71.1028 52.5553 67.8708C52.5553 64.6389 51.8045 63.1472 50.1955 63.1472H44.8324ZM44.8324 104.168V113.864H51.0536C53.0916 113.864 53.5207 112.124 53.5207 108.892C53.5207 105.66 52.6626 104.168 50.9464 104.168H44.8324Z"
        fill="white"
      />
    </svg>
  );
};

const BorveySvg = () => {
  return (
    <svg
      width="1416"
      height="755"
      viewBox="0 0 1416 755"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1231.4 754.5V123.04L1158.47 5.19971H1270.42L1284.41 35.6797L1286.83 73.3597L1289.52 35.4397L1302.71 5.19971H1416L1343.07 123.04V754.5H1231.4Z"
        fill="white"
      />
      <path
        d="M1167 751H969V5H1167V531.867H1070.69V544.361H1167V604.911H1070.69V617.886H1167V751Z"
        fill="white"
      />
      <path
        d="M783.66 747L724 5H834.451L847.888 128.375L850.306 234.713L852.994 127.788L867.237 5H975L913.459 747H783.66Z"
        fill="white"
      />
      <path
        d="M603.508 127.033V173H496V5H623.935C648.393 5 668.551 6.86667 685.214 9.89999C718.273 16.6667 734.937 31.3667 734.937 57.9667C734.937 68.2333 731.712 76.1667 724.992 81.7667C712.091 92.7333 688.171 96.4667 657.531 97.6333C688.44 97.6333 707.254 99.9667 718.004 106.733C728.486 113.967 731.98 126.567 731.98 148.033V157.833C731.98 166 736.55 170.433 743 173H620.978C615.334 170.433 613.184 165.767 613.184 161.8V132.867C613.184 127.967 611.034 127.033 604.583 127.033H603.508ZM603.508 70.5667V86.2H610.765C617.215 86.2 620.172 83.4 620.172 78.0333C620.172 73.1333 617.215 70.5667 610.765 70.5667H603.508Z"
        fill="white"
      />
      <path
        d="M365.327 173C335.976 173 312.549 169.809 294.508 163.655C258.156 150.891 242 125.59 242 86.8419V86.614C242 32.1383 284.545 0 368.289 0C395.755 0 417.835 3.41897 435.876 10.4848C472.228 24.6166 490 50.8287 490 86.8419V87.0698C490 146.104 452.033 173 365.327 173ZM365.865 96.6429C375.559 96.6429 379.868 93.9078 379.868 86.8419C379.868 80.2319 375.559 77.0408 366.135 77.0408C356.71 77.0408 352.132 80.2319 352.132 86.8419C352.132 93.9078 356.979 96.6429 365.865 96.6429Z"
        fill="white"
      />
      <path
        d="M0 740V5H139.215C162.911 5 181.49 12.1458 196.031 25.4166C224.844 52.9792 236.961 108.104 236.961 193.854C236.961 225.5 235.076 253.062 231.845 274.5C224.574 321.458 208.418 349.021 175.836 362.292C192.531 367.396 205.187 376.583 214.611 389.854C233.73 415.375 241 460.292 241 531.75C241 580.75 236.961 619.542 228.613 651.187C211.918 712.437 181.49 740 139.753 740H0ZM105.017 264.292V304.104H118.211C122.52 304.104 124.404 296.958 124.404 283.688C124.404 270.417 122.52 264.292 118.48 264.292H105.017ZM105.017 432.729V472.542H120.635C125.751 472.542 126.828 465.396 126.828 452.125C126.828 438.854 124.674 432.729 120.365 432.729H105.017Z"
        fill="white"
      />
    </svg>
  );
};

const LiveIcon = () => {
  return (
    <svg
      width="123"
      height="16"
      viewBox="0 0 123 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M122.707 8.70711C123.098 8.31658 123.098 7.68342 122.707 7.29289L116.343 0.928932C115.953 0.538408 115.319 0.538408 114.929 0.928932C114.538 1.31946 114.538 1.95262 114.929 2.34315L120.586 8L114.929 13.6569C114.538 14.0474 114.538 14.6805 114.929 15.0711C115.319 15.4616 115.953 15.4616 116.343 15.0711L122.707 8.70711ZM0 9H122V7H0V9Z"
        fill="white"
        fill-opacity="0.5"
      />
    </svg>
  );
};

const RotateIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6663 37.5H11.333C9.67615 37.5 8.33301 36.1569 8.33301 34.5V15.5C8.33301 13.8431 9.67615 12.5 11.333 12.5H38.6663C40.3232 12.5 41.6663 13.8431 41.6663 15.5V34.5C41.6663 36.1569 40.3232 37.5 38.6663 37.5H24.9997M24.9997 37.5L31.2497 31.25M24.9997 37.5L31.2497 43.75"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 11.0268V8.97321H11.0375V0H8.91832V8.97321H0V11.0268H8.91832V20H11.0375V11.0268H20Z"
        fill="#4D4D4D"
      />
    </svg>
  );
};

const ArrowTop = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9999 8V21C24.9999 21.2652 24.8946 21.5196 24.7071 21.7071C24.5195 21.8946 24.2652 22 23.9999 22C23.7347 22 23.4804 21.8946 23.2928 21.7071C23.1053 21.5196 22.9999 21.2652 22.9999 21V10.4137L8.70745 24.7075C8.51981 24.8951 8.26531 25.0006 7.99995 25.0006C7.73458 25.0006 7.48009 24.8951 7.29245 24.7075C7.1048 24.5199 6.99939 24.2654 6.99939 24C6.99939 23.7346 7.1048 23.4801 7.29245 23.2925L21.5862 9H10.9999C10.7347 9 10.4804 8.89464 10.2928 8.70711C10.1053 8.51957 9.99995 8.26522 9.99995 8C9.99995 7.73478 10.1053 7.48043 10.2928 7.29289C10.4804 7.10536 10.7347 7 10.9999 7H23.9999C24.2652 7 24.5195 7.10536 24.7071 7.29289C24.8946 7.48043 24.9999 7.73478 24.9999 8Z"
        fill="#343330"
      />
    </svg>
  );
};

export {
  HomePageSvg,
  HomePageSvgMobile,
  DanteSvg,
  VialandSvg,
  DesteSvg,
  MuralSvg,
  BubbleSvg,
  PeanutSvg,
  SSSvg,
  ToolsySvg,
  GolfSvg,
  PremeyoumSvg,
  OusSvg,
  SafeKidsSvg,
  AremasSvg,
  MoveOnSvg,
  KubraSvg,
  ContactSvg,
  InstagramIcon,
  GithubIcon,
  LiveIcon,
  RotateIcon,
  PlusIcon,
  FratelliSvg,
  MCSSvg,
  YumacareSvg,
  BayetavSvg,
  BorveySvg,
  ArrowTop,
};
